// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, validLicenceNumber, createDefaultVehicle, createDefaultEmployerDetails } from '../../constants/globalConstants'
import {
	fileChangedHandler, universityUploadHandler, isLoggedIn, isPermissionExist, perkingParkingTime,
	restrictInValidCharLicense, restrictSpecialChar, sortPortalPermissionByKey, validateEmail,
	isVehicleLimitExceeded, getAcceptedFiles, formatKeyInDocumentName, isValuePresentInArray,
	getAcceptedDocument, multiFileChangedHandler, restrictInputValues,
	restrictLeadingTrailingSpace,
	formatDecimal
} from '../../utils/helper'
// AllowededTime
import { getFacilityList, permitRateList, permitCategoryList, permitCategoryServiceList, getPermitByEmail, getDocumentTypes } from '../../redux/actions/BasicInfoAction'
import { Circles } from 'react-loader-spinner'
import FileUpload from '../../components/fileUpload/FileUpload'
import { getVehicleDataList, getVehicleModelList, getVehicleModelListPermission } from '../../redux/actions/VehicleListAction'
import './home.scss'
import { useParams } from 'react-router-dom'
// import URL from '../../constants/urls'
import debounce from 'lodash/debounce'
import Multiselect from 'multiselect-react-dropdown'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import DocumentUpload from '../../components/fileUpload/DocumentUpload'
import moment from 'moment'
import { MultiSelectInput, TextInput } from '../../Global/Form'
import useMobileView from '../../Hooks/useMobileView'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { getPermitDetailsById } from '../../redux/actions/PermitRequestAction'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')

function Home(props) {
	const { setPage, setIdProof, idProof, dispatch, formData, setFormData, formError, partnerDetails,
		setUniversityidProof, universityidProof, vehicleListArray, setVehicleListArray, setvehicleCount,
		vehicleCount, VehiclePrev, loader, categoryURL, setMainVehicleMakeList, selectedVehicleList,
		setSelectedVehicleList, setDocumentTypes, documentTypes, notify, setMultiIdProof, idMultiProof,
		employerDetails, setEmployerDetails, validator, accessPermissions
	} = props

	const { facility } = useParams()
	// const navigate = useNavigate()
	const searchParams = new URLSearchParams(location.search)
	const [resident, setResident] = useState()
	const [countryChange, setCountryChange] = useState(true)
	const [faclityList, setFaclityList] = useState(EMPTY_ARRAY)
	const [selectedFaclity, setSelectedFacilty] = useState(EMPTY_ARRAY)
	const [permitPrices, setPermitPrices] = useState(EMPTY_ARRAY)
	const [permitList, setPermit] = useState(EMPTY_ARRAY)
	const [categoryServiceList, setCategoryServiceList] = useState(EMPTY_ARRAY)
	const [permitRateError, setPermitRateError] = useState('')
	const [idErrProof, setIdErrProof] = useState({})
	const partner = window.location.toString().split('/')[3]
	const promotion = window.location.toString().split('/')[4]
	const [error, setError] = useState(false)
	const [ruleOpen, setRuleOpen] = useState(false)
	const [vehicleListLocal, setvehicleListLocal] = useState(EMPTY_ARRAY)


	// vehicle
	// const [isVehicleTableVisible, setIsVehicleTableVisible] = useState(false)
	// const [vehicleList, setVehicleList] = useState(EMPTY_ARRAY)
	const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)
	const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
	const [vehicleModelList, setvehicleModelList] = useState(EMPTY_ARRAY)
	const [vehicleCountList, setvehicleCountList] = useState(EMPTY_ARRAY)
	// const [permitService, setPermitService] = useState(EMPTY_ARRAY)
	const [permitCategory, setPermitCategory] = useState(EMPTY_ARRAY)
	// const [permitServiceForm, setPermitServiceForm] = useState(EMPTY_ARRAY)
	// const [permitServiceRate, setPermitServiceRate] = useState(0)
	const zoneList = [{ val: 'A', name: 'A' }, { val: 'B', name: 'B' }, { val: 'C', name: 'C' }]

	// for disbaled functionallty 
	const [loginData, setLoginData] = useState(EMPTY_OBJECT)
	const [isServiceDisabled, setIsServiceDisabled] = useState(true)
	const [isDisplayFacility, setIsDisplayFacility] = useState(false) //PIMS-11105
	const [isVehicleDisabled, setIsVehicleDisabled] = useState(false)
	const [isStaffDisabled, setIsStaffDisabled] = useState(true)
	const [desiredStartDate, setDesiredStartDate] = useState(new Date())
	const [desiredMinStartDate, setDesiredMinStartDate] = useState(new Date())
	const [desiredEndDate, setDesiredEndDate] = useState('')
	const [multivehicleDetailsList, setMultivehicleDetailsList] = useState(EMPTY_ARRAY)
	const [stateloader, setStateloader] = useState(null)
	const [categoryLoader, setCategoryLoader] = useState(false)
	const [isDisplayReason, setIsDisplayReason] = useState(false)
	const [universityidErrProof, setUniversityidErrProof] = useState({})

	// to show the model in vehicle 
	const [is_modal_show, setIsShowModalInVehicle] = useState(false)
	const [invalidEmailPermit, setInvalidEmailPermit] = useState('')

	const [fetchingDocumentTypes, setFetchingDocumentTypes] = useState(false)
	const [selectedDocumentType, setSelectedDocumentType] = useState(EMPTY_OBJECT)
	// const navigate = useNavigate()

	const isMobile = useMobileView()

	const [expanded, setExpanded] = useState(false)
	const [isOverflowing, setIsOverflowing] = useState(false)
	const [PTnC, setPTnC] = useState(false)
	const [permitDetailsById, setPermitDetailsById] = useState(EMPTY_OBJECT)

	const contentRef = useRef(null)


	useEffect(() => {
		const contentHTML =
			selectedFaclity?.facility_configuration?.permit_terms_condition_content &&
				selectedFaclity?.facility_configuration?.permit_terms_condition_content.trim() !== ''
				? selectedFaclity?.facility_configuration?.permit_terms_condition_content
				: partnerDetails?.brand_setting?.permit_terms_condition_content
		setPTnC(contentHTML)
	}, [selectedFaclity, partnerDetails])

	useEffect(() => {
		const el = contentRef.current
		if (el) {
			const lineHeight = parseFloat(getComputedStyle(el).lineHeight)
			const maxHeight = lineHeight * 5 // ~5 lines
			setIsOverflowing(el.scrollHeight > maxHeight)
		}
	}, [PTnC])

	useEffect(() => {
		if (facility) {
			setFormData({ ...formData, ['facility_id']: facility })
		}
	}, [EMPTY_ARRAY, facility])


	useEffect(() => {
		getVehical()
	}, [partnerDetails])

	useEffect(() => {
		if (!formData?.facility_id) {
			localStorage.removeItem('facility')
		}
		setFormData({ ...formData, ['zone']: 'A' })
		localStorage.setItem('zone', formData?.zone ? formData?.zone : 'A')

		// this commented code moved below after facilityList Api call because faclityList getting empty after coming back from signup page
		// if (formData?.facility_id || facility) {
		// 	retrievePermitData(formData?.license_number, formData?.facility_id)
		// }
		if (formData?.permit_type) {
			const selectedPermit = permitList?.filter((item) => item?.id == Number(formData?.permit_type))
			setPermitTypes(selectedPermit)
		}
		if (formData?.permitService) {
			if (formData?.permitService?.some(item => item?.display_facility == 1)) {
				setIsDisplayFacility(true)
				const param = {
					services: formData?.permitService?.map((item) => item?.id)?.toString(),
					permittype: formData?.permit_type || '',
				}
				dispatch(getFacilityList(partner, param)).then((res) => {
					setFaclityList(res)
				})
			} else {
				setIsDisplayFacility(false)
			}
		}

		if (formData?.desired_start_date) {
			setDesiredStartDate(formData?.desired_start_date)
		}
		if (formData?.license_number) {
			const userData = localStorage.getItem('userData') ? localStorage.getItem('userData') : '{}'
			const user = JSON.parse(userData)
			const license_number = user?.user?.license_number
			const handlingLicenseChange = {
				target: {
					value: isLoggedIn() ? license_number : formData?.license_number
				}
			}
			handleLicenceNumberChange(handlingLicenseChange)
		}
		if (isPermissionExist(accessPermissions, 'Permit Category')) { permitCategoryData() }
		setPage('home')
		dispatch(getFacilityList(partner)).then((res) => {
			let facilityArray = res
			if (facility) {
				facilityArray = res?.filter((facilityItem) => facilityItem?.id == facility)
				setFaclityList(facilityArray)
			} else {
				setFaclityList(res)
			}

			const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')

			if (formData?.facility_id || facility) {
				retrievePermitData(formData?.license_number, formData?.facility_id || (facilityArray?.[0]?.id), facilityArray)
			}

			// this is because useEffect called before the facility value settle into the usestate
			// we are already saving the facility into the local instantly while clicking the facility_id input with the lable of Parking Location
			// so tryed to handle the undefined && null senerio with the local storage value
			const getSelectedFacilityFromLocal = localStorage.getItem('facility') ? JSON.parse(localStorage.getItem('facility')) : ''

			// end here 

			if (res?.length == 1 || (isPermissionExist(getAccessPermissionData, 'Hide Facility') && !isDisplayFacility)) {  //PIMS-11105
				setSelectedFacilty(res?.[0])
				localStorage.setItem('facility', JSON.stringify(res?.[0]))
				setFormData({ ...formData, 'selFaclity': res?.[0], ['facility_id']: res?.[0]?.id, 'permitNegotiate': res?.[0]?.is_permit_purchase_enabled == '0' ? '1' : '0' })
				const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
				if (!isPermissionExist(getAccessPermissionData, 'Driving License')) {
					retrievePermitData(formData?.license_number, res?.[0]?.id, facilityArray)
				} else {
					!isPermissionExist(accessPermissions, 'Get Permit By Email') ? retrievePermitData('', res?.[0]?.id, facilityArray) : null
				}
			} else {
				const selFaclity = res?.filter((item) => item?.id == Number(formData?.facility_id || facility || getSelectedFacilityFromLocal?.id))
				const selectedFacility = selFaclity?.[0] ?? getSelectedFacilityFromLocal

				setSelectedFacilty(selectedFacility)
				localStorage.setItem('facility', JSON.stringify(selectedFacility || {}))
				setFormData({ ...formData, 'selFaclity': selectedFacility, ['facility_id']: selectedFacility?.id, 'permitNegotiate': selectedFacility?.is_permit_purchase_enabled == '0' ? '1' : '0' })
				const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
				if (!isPermissionExist(getAccessPermissionData, 'Driving License')) {
					retrievePermitData(formData?.license_number, selectedFacility?.id, facilityArray)
				} else {
					retrievePermitData('', selectedFacility?.id, facilityArray)
				}
			}
		})
		if (isLoggedIn()) {
			const userData = localStorage.getItem('userData')
			const user = JSON.parse(userData)
			// save loginUserData
			setLoginData(searchParams?.get('permitID') ? null : user?.user)
			const license_number = user?.user?.license_number ? user?.user?.license_number : formData?.license_number
			isPermissionExist(accessPermissions, 'Get Permit By Email') ? getPermitEmailID(user?.user?.email) : null
			formData['license_number'] = license_number
			setFormData({ ...formData })
			if (VehiclePrev && countryChange) {

				//set country selection  for login user call one time
				let multivehicleExist = multivehicleDetailsList
				for (let i = 1; i < vehicleCount; i++) {
					multivehicleExist.splice(vehicleCount, 0, vehicleDetailsList)
				}
				setMultivehicleDetailsList(multivehicleExist)
				//end

				dispatch(getVehicleDataList()).then((res) => {
					let payloadData = { ...formData }
					let vehicleCopy = []
					res?.data?.map((value) => {
						let copy = { ...value }
						let modelData = vehicleDetailsList?.make?.filter((v) => v.name == copy?.make)
						let modelList = (modelData?.length != 0 ? modelData?.[0]?.mst_model : [])
						let filteredmakemodelList = modelList?.filter((v) => v.name == copy?.model)
						// // setvehicleModelList(modelData?.[0]?.mst_model)
						let check = modelList?.some((value) => value?.name == 'Others')
						if (!check && modelList != undefined) {
							modelList.unshift({
								'id': 'Others',
								'make_id': 'Others',
								'name': 'Others'
							})
						}
						copy['license_plate'] = copy?.license_plate_number
						copy['maketext'] = copy?.make ? copy?.make : ''
						copy['make'] = (modelData?.length == 0 && copy?.make != '') ? '' : copy?.make ? copy?.make : ''
						copy['othermake'] = modelData?.length == 0 ? true : false
						copy['othermodel'] = filteredmakemodelList?.length == 0 ? true : false
						copy['modeltext'] = copy?.model ? copy?.model : ''
						copy['model'] = filteredmakemodelList?.length == 0 ? '' : copy.model ? copy?.model : ''
						copy['vehicleList'] = modelList != undefined ? modelList : vehicleModelList
						copy['is_modal_show'] = is_modal_show || false
						delete copy['license_plate_number']
						vehicleCopy.push(copy)
					})
					payloadData['vehicleList'] = vehicleCopy
					setvehicleCount(vehicleCopy.length)
					setvehicleCountList(vehicleCopy)
					setFormData(payloadData)
					// PIMS-13993
					if (partner == 'menlo') {
						const filterVehicle = vehicleCopy?.filter((vehicle) => vehicle?.is_default == 1)
						setVehicleListArray((filterVehicle && filterVehicle?.length > 0) ? filterVehicle : vehicleCopy[0] ? [vehicleCopy[0]] : vehicleListArray)
						setvehicleListLocal((filterVehicle && filterVehicle?.length > 0) ? filterVehicle : vehicleCopy[0] ? [vehicleCopy[0]] : vehicleListArray)
					} else {
						setVehicleListArray((vehicleCopy && vehicleCopy?.length > 0) ? vehicleCopy : vehicleListArray)
						setvehicleListLocal((vehicleCopy && vehicleCopy?.length > 0) ? vehicleCopy : vehicleListArray)

					}
					let selectedVehicles = selectedVehicleList?.slice() ?? []
					let vehicleArrayList = selectedVehicles?.length > 0 ? selectedVehicles : [createDefaultVehicle(formData?.country ? formData?.country : partnerDetails?.facilities?.[0]?.country_code, true)]
					setSelectedVehicleList(vehicleCopy?.length > 0 ? EMPTY_ARRAY : vehicleArrayList)
					if (res?.data?.length == 5) {
						// dougth full change vehcle table true kiya hai
						// setIsVehicleTableVisible(false) 
						// setIsVehicleTableVisible(true)
					} else {
						// setIsVehicleTableVisible(true)
					}
				})
			}


		} else {
			let selectedVehicles = selectedVehicleList?.slice() ?? []
			let vehicleArrayList = selectedVehicles?.length > 0 ? selectedVehicles : [createDefaultVehicle(formData?.country ? formData?.country : partnerDetails?.facilities?.[0]?.country_code, true)]
			setSelectedVehicleList(vehicleArrayList)
		}
	}, [EMPTY_ARRAY, vehicleDetailsList, partnerDetails])

	useEffect(() => {
		let uploadedKeys = idMultiProof?.map(doc => doc?.type)
		let notUploadedElements = documentTypes.filter(doc => !uploadedKeys?.includes(doc?.document_key))
		setSelectedDocumentType(notUploadedElements?.[0])
		if (notUploadedElements && notUploadedElements?.length > 0) {
			setFormData({ ...formData, 'document_type': notUploadedElements?.[0]?.document_key })
		} else {
			const lastIndex = documentTypes?.length - 1
			const lastDocumentType = documentTypes?.[lastIndex]
			setFormData({ ...formData, 'document_type': lastDocumentType?.document_key })
		}
	}, [EMPTY_ARRAY, idMultiProof, documentTypes])

	useEffect(() => {
		if (formData?.permit_type) {
			const selectedPermit = permitList?.filter((item) => item?.id == Number(formData?.permit_type))
			setPermitTypes(selectedPermit)
		}

	}, [EMPTY_ARRAY, permitList])

	// EOS-2427
	useEffect(() => {
		if (faclityList?.length > 0 && searchParams?.get('permitID')) {
			dispatch(getPermitDetailsById(searchParams?.get('permitID'))).then((res) => {
				if (res?.id) {
					setPermitDetailsById(res)
					if (res?.facility?.id) {
						const selFaclity = faclityList?.filter((item) => item?.id == res?.facility?.id)
						setDocumentTypes([])
						setSelectedDocumentType(null)
						setEmployerDetails(createDefaultEmployerDetails(formData?.country))
						// Always update localStorage, selectedFacility, and formData as soon as there is a selection
						if (selFaclity?.[0]) {
							localStorage.setItem('facility', JSON.stringify(selFaclity?.[0]))
							setSelectedFacilty(selFaclity?.[0])
							setFormData(prev => ({
								...prev,
								'selFaclity': selFaclity?.[0],
								'facility_id': Number(res?.facility?.id),
								'permitNegotiate': selFaclity?.[0]?.is_permit_purchase_enabled == '0' ? '1' : '0'
							}))
							retrievePermitData(formData?.license_number, Number(res?.facility?.id), faclityList, res)
						}
					}
					// if(res?.permit_vehicle && res?.permit_vehicle?.length > 0){

					// 	const vehicleList = (res?.permit_vehicle || []).map((item) => {
					// 		const vehicle = item?.vehicle || {}

					// 		const license = vehicle?.license_plate_number || ''

					// 		const formattedPlate = restrictInValidCharLicense(license)?.replace(
					// 			/[^a-zA-Z0-9]/g,
					// 			''
					// 		)

					// 		return {

					// 			id: item?.id,
					// 			permit_vehicle_id: item?.permit_vehicle_id,
					// 			permit_request_id: item?.permit_request_id,


					// 			license_plate: formattedPlate,


					// 			model_id: vehicle?.model_id && vehicle?.model_id !== 'Others' ? vehicle?.model_id : '',
					// 			modeltext: vehicle?.model_id === 'Others' ? '' : vehicle?.model || '',
					// 			vehicle_type: vehicle?.vehicle_type || '',
					// 			vehicle_type_id: vehicle?.vehicle_type_id || '',

					// 			style: vehicle?.style || '',
					// 			style_id: vehicle?.style_id || '',
					// 			color: vehicle?.color || '',
					// 			color_id: vehicle?.color_id || '',
					// 			country: vehicle?.country || '',
					// 			state_id: vehicle?.state_id || '',
					// 			state_name: vehicle?.state_name || '',
					// 			state_code: vehicle?.state_code || '',

					// 			make: vehicle?.make || '',
					// 			make_id: vehicle?.make_id || '',
					// 		}
					// 	})

					// 	setSelectedVehicleList(vehicleList)
					// }
					let selectedVehicles = selectedVehicleList?.slice() ?? []
					let vehicleArrayList = selectedVehicles?.length > 0 ? selectedVehicles : [createDefaultVehicle(formData?.country ? formData?.country : partnerDetails?.facilities?.[0]?.country_code, true)]
					setSelectedVehicleList(vehicleArrayList)
					if (res?.user && res?.user?.name) {
						formData['user_id'] = res?.user?.id
						formData['firstname'] = restrictLeadingTrailingSpace(res?.user?.first_name)
						formData['lastname'] = restrictLeadingTrailingSpace(res?.user?.last_name)
						// formData['email'] = restrictLeadingTrailingSpace(res?.user?.email)
						formData['phone'] = restrictLeadingTrailingSpace(res?.user?.phone_number)
						formData['address1'] = restrictLeadingTrailingSpace(res?.user?.address)
						formData['address2'] = restrictLeadingTrailingSpace(res?.user?.address2)
						formData['city'] = restrictLeadingTrailingSpace(res?.user?.city)
						formData['country'] = searchParams?.get('permitID') ? formData?.country : restrictLeadingTrailingSpace(res?.user?.country)
						formData['state'] = restrictLeadingTrailingSpace(res?.user?.state)
						formData['zipcode'] = restrictLeadingTrailingSpace(res?.user?.pincode)
						setFormData({ ...formData })
					}
				} else {
					setPermitDetailsById(null)
				}
			}).catch((err) => {
				setPermitDetailsById(null)
				console.log(err)
			})
		}
	}, [searchParams?.get('permitID'), faclityList])

	const getVehical = () => {
		dispatch(getVehicleModelListPermission(formData?.country ? formData?.country : partnerDetails?.facilities?.[0]?.country_code)).then((res) => {
			let makeList = res?.make
			// To identify if the model is available or not 
			const allHaveMst_model = makeList?.every(makeObj => Object.hasOwn(makeObj, 'mst_model')) ?? false
			if (allHaveMst_model) {
				makeList?.unshift({ 'id': 'Others', 'name': 'Others', 'mst_model': [{ 'id': 'Others', 'make_id': 'Others', 'name': 'Others' }] })
			}
			setVehicleMakeList(makeList)
			setVehicleDetailsList(res)
			setMainVehicleMakeList(makeList)
			let multivehicle = [...multivehicleDetailsList]
			multivehicle.splice(0, 1, res)
			setMultivehicleDetailsList(multivehicle)
			setFormData({ ...formData, ['allModel']: res, 'multivehicleList': formData?.multivehicleList ? formData?.multivehicleList : multivehicle })

			// to add a key related to show the modal
			const vehicleData = vehicleListArray.map(item => ({ ...item, is_modal_show: allHaveMst_model }))
			// to set this in local to manage model on other files
			localStorage.setItem('allHaveMst_model', JSON.stringify(allHaveMst_model))
			setVehicleListArray(vehicleData)
			setvehicleListLocal(vehicleData)
			setIsShowModalInVehicle(allHaveMst_model)
			// setValue('country', res.country[0].name)
			// if (BookingEdit) {
			// 	let model = (res?.make?.length > 0) && res?.make?.filter((v) => v?.name == BookingEditData?.vehical_details?.make)
			// 	setvehicleModelList(model[0]?.mst_model)
			// }

		})

	}


	// useEffect(() => {
	// 	permitList
	// 	const selectedPermit = faclityList?.filter((item) => item?.id == Number(value))
	// 	setPermitTypes()
	// }, [EMPTY_ARRAY, permitList])

	const retrievePermitData = (license_number, facility_id = searchParams?.get('facility'), defaultFaclityList = faclityList, permitData = {}) => {
		formData.facility_id = facility_id
		const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
		if (!isPermissionExist(getAccessPermissionData, 'Get Permit By Email')) {
			if (isPermissionExist(getAccessPermissionData, 'Permit Category')) {
				if (facility_id && (formData?.selectedCategory?.id || searchParams?.get('permitCategory'))) {
					const permitPayload = {
						'facility_id': facility_id,
						'is_promotion': promotion && promotion != '' && promotion == 'permittype2' ? '1' : searchParams?.get('permitID') ? '1' : '0',
						'driving_license': !isPermissionExist(accessPermissions, 'Driving License') ? license_number ? license_number?.trim() : '' : '',
						category_id: formData?.selectedCategory?.id ? formData?.selectedCategory?.id : searchParams?.get('permitCategory') || ''
					}
					const curFacility = defaultFaclityList?.filter((item) => item?.id == Number(facility_id))
					if ((curFacility.length > 0 && curFacility[0]?.facility_configuration?.permit_upload_docs_enabled == '1') || (facility_id == formData?.selFaclity?.id && formData?.selFaclity?.facility_configuration?.permit_upload_docs_enabled == '1')) {
						permitPayload.is_permit_type = '1'
					}
					// if (validLicenceNumber.test(license_number?.trim())) {
					dispatch(permitRateList(permitPayload)).then((res) => {
						if (res?.data?.length == 1) {
							const selFaclity = defaultFaclityList?.filter((item) => item?.id == Number(facility_id))
							setFormData({ ...formData, ...{ permit_type: res?.data?.[0]?.id }, 'permit_list_data': res?.data, facility_id: facility_id, 'permit_type_name': res?.data?.[0]?.name ? res?.data?.[0]?.name : '', 'selFaclity': selFaclity?.[0], 'permitNegotiate': selFaclity?.[0]?.is_permit_purchase_enabled == '0' ? '1' : '0', is_hide_vehicle: res?.data?.[0]?.permit_rate?.[0]?.is_hide_vehicle == 1 ? true : false, is_hide_permit_service: res?.data?.[0]?.permit_rate?.[0]?.is_hide_permit_service == 1 ? true : false, is_hide_staff: res?.data?.[0]?.permit_rate?.[0]?.is_hide_staff == 1 ? true : false })
						}
						// setPermit(res?.data)
						if (isPermissionExist(accessPermissions, 'Permit Category')) {//USM
							if (formData?.permit_category && formData?.permit_category != '' && !isDisplayFacility) { //PIMS-11105
								// if (formData?.permit_category && formData?.permit_category != '') {
								setPermit(formData?.permit_list_data)
							} else {
								setPermit(res?.data) //PIMS-11105
								// setPermit([])
							}
							retriveURLData()
						} else {
							setPermit(res?.data)
						}

						if (searchParams?.get('permitID') && permitData && permitData?.permit_rate?.permit_rate_description_id) {
							handlePermitTypeChange('permit_type', permitData?.permit_rate?.permit_rate_description_id)
							formData.permit_type = permitData?.permit_rate?.permit_rate_description_id
							let selectedPermit = res?.data?.filter((item) => item?.id == Number(permitData?.permit_rate?.permit_rate_description_id))
							setPermitTypes(selectedPermit)
						}
					})
				}
			} else {
				if (facility_id) {
					const { user_type, id } = partnerDetails || {}
					const permitPayload = {
						'facility_id': facility_id,
						'is_promotion': promotion && promotion != '' && promotion == 'permittype2' ? '1' : searchParams?.get('permitID') ? '1' : '0',
						'driving_license': !isPermissionExist(accessPermissions, 'Driving License') ? license_number ? license_number?.trim() : '' : '',
						category_id: formData?.selectedCategory?.id ? formData?.selectedCategory?.id : '',
						bussiness_id: user_type === '4' ? id : '',
					}
					const curFacility = defaultFaclityList?.filter((item) => item?.id == Number(facility_id))
					if ((curFacility.length > 0 && curFacility[0]?.facility_configuration?.permit_upload_docs_enabled == '1') || (facility_id == formData?.selFaclity?.id && formData?.selFaclity?.facility_configuration?.permit_upload_docs_enabled == '1')) {
						permitPayload.is_permit_type = '1'
					}
					// if (validLicenceNumber.test(license_number?.trim())) {
					dispatch(permitRateList(permitPayload)).then((res) => {
						if (res?.data?.length == 1) {
							const selFaclity = defaultFaclityList?.filter((item) => item?.id == Number(facility_id))
							setFormData({ ...formData, ...{ permit_type: res?.data?.[0]?.id }, 'permit_list_data': res?.data, facility_id: facility_id, 'permit_type_name': res?.data?.[0]?.name ? res?.data?.[0]?.name : '', 'selFaclity': selFaclity?.[0], 'permitNegotiate': selFaclity?.[0]?.is_permit_purchase_enabled == '0' ? '1' : '0', is_hide_vehicle: res?.data?.[0]?.permit_rate?.[0]?.is_hide_vehicle == 1 ? true : false, is_hide_permit_service: res?.data?.[0]?.permit_rate?.[0]?.is_hide_permit_service == 1 ? true : false, is_hide_staff: res?.data?.[0]?.permit_rate?.[0]?.is_hide_staff == 1 ? true : false })
						}
						// setPermit(res?.data)
						if (isPermissionExist(accessPermissions, 'Permit Category')) {//USM
							if (formData?.permit_category && formData?.permit_category != '' && !isDisplayFacility) { //PIMS-11105
								// if (formData?.permit_category && formData?.permit_category != '') {
								setPermit(formData?.permit_list_data)
							} else {
								setPermit(res?.data) //PIMS-11105
								// setPermit([])
							}
							retriveURLData()
						} else {
							setPermit(res?.data)
						}
						if (searchParams?.get('permitID') && permitData && permitData?.permit_rate?.permit_rate_description_id) {
							handlePermitTypeChange('permit_type', permitData?.permit_rate?.permit_rate_description_id)
							formData.permit_type = permitData?.permit_rate?.permit_rate_description_id
							let selectedPermit = res?.data?.filter((item) => item?.id == Number(permitData?.permit_rate?.permit_rate_description_id))
							setPermitTypes(selectedPermit)
							const selFaclity = defaultFaclityList?.filter((item) => item?.id == Number(facility_id))
							setFormData({ ...formData, 'selFaclity': selFaclity?.[0] })
						}

					})
				}
			}

		}
		// Uncommented For Menlo Permit Reset on Back Click
		else {
			if (formData?.permit_list_data || permitList?.length > 0) {
				// code add for autofill data go and previous form. && PIMS-15005
				let permit = permitList?.length > 0 ? permitList : formData?.permit_list_data
				setPermit(permit)
			}
			else {
				if (formData?.permit_list_data || permitList?.length > 0) {
					// code add for autofill data go and previous form. && PIMS-15005
					let permit = permitList?.length > 0 ? permitList : formData?.permit_list_data
					setPermit(permit)
				}

			}
			// if (isPermissionExist(accessPermissions, 'Permit Category')) { permitCategoryData() }//for usmparking where allow category
		}
	}

	const permitCategoryData = () => {

		dispatch(permitCategoryList(partnerDetails.id, searchParams?.get('permitCategory'))).then((res) => {
			if (res?.data?.length > 0) {
				setPermitCategory(res?.data)
			}
			if (res?.data?.length == 1) {
				setFormData({ ...formData, selectedCategory: res?.data?.[0] ? res?.data?.[0] : {}, permit_category: res?.data?.length == 1 ? res?.data?.[0]?.id : '', is_hide_vehicle: res?.data?.[0]?.is_hide_vehicle == 1 ? true : false, is_hide_permit_service: res?.data?.[0]?.is_hide_permit_service == 1 ? true : false, is_hide_staff: res?.data?.[0]?.is_hide_staff == 1 ? true : false })
			}
			// if(formData?.permit_category && formData?.permit_category!='' ){
			// 	setPermit(formData?.permit_list_data)
			// 	// permitCategoryService(formData?.permit_category)
			// }else{				
			// 	setPermit([])
			// }
			//set blank if caltegory not select USM partner
		})
	}
	const permitCategoryService = (id, facility_id = partnerDetails?.facilities?.[0]?.id) => { //PIMS-11105
		// const permitCategoryService = (id) => {
		setCategoryLoader(true)
		const selectedCategory = permitCategory?.filter((item) => item?.id == id)

		let facility_idS = localStorage.getItem('facility') && localStorage.getItem('facility') != undefined ? JSON.parse(localStorage.getItem('facility')) : {}
		let payloadGetService = {
			partner_id: partnerDetails?.user_type === '3' ? partnerDetails?.id : partnerDetails?.partner_name?.id || '',
			category_id: id,
			facility_id: formData?.facility_id ? formData?.facility_id : facility_idS?.id ? facility_idS?.id : facility_id, //PIMS-11105
			business_id: partnerDetails?.user_type === '4' ? partnerDetails?.id : '',
		}
		if (searchParams?.get('permitType') && searchParams?.get('permitType') != '') {
			payloadGetService.is_promotion = 2
		}

		let selFaclity = faclityList?.filter((item) => item?.id == Number(formData?.facility_id))//for permitNegotiate reset 
		// Get List 
		dispatch(permitCategoryServiceList(payloadGetService)).then((res) => {
			if (res?.data) {
				let permitType = searchParams?.get('permitType')
				if (permitType) {

					let selectedPermit = res?.data?.permit?.filter((item) => item?.id == Number(permitType))
					setPermitTypes(selectedPermit)
				}
				setPermit(res?.data?.permit)
				setCategoryServiceList(res?.data?.permit_services)
				//reset permit if category PIMS-14266
				const permitRest = { permit_list_data: [], permit_rate: '', permit_rate_id: '', permit_type: '', selectedPermitType: [], permit_type_name: '' }
				// handlePermitTypeChange('permit_type', '')
				setPermitPrices([])
				setFormData({ ...formData, ...permitRest, selectedCategory: selectedCategory?.[0] ? selectedCategory?.[0] : {}, 'permit_type': permitType ? permitType : (res?.data?.permit && res?.data?.permit?.length == 1) ? res?.data?.permit?.[0]?.id : '', 'permit_list_data': res?.data?.permit, 'permitService': [], 'permitServicePrice': 0, 'permitServiceList': res?.data?.permit_services, 'permit_category': id, 'permitNegotiate': selFaclity?.[0]?.is_permit_purchase_enabled == '0' ? '1' : '0' })
				if (res?.data?.permit?.length == 1) {
					handlePermitTypeChange('permit_type', res?.data?.permit?.[0]?.id)
				}
				// setFormData({ ...formData,'permit_list_data':res?.data?.permit,'permitService': [], 'permitServicePrice': 0, 'permitServiceList': res?.data?.permit_services, 'permit_category': id,  'permitNegotiate': selFaclity?.[0]?.is_permit_purchase_enabled == '0' ? '1' : '0' })
			}
			setCategoryLoader(false)
		})
	}

	const deb = useCallback(
		debounce((license_number, facility_id) => {

			retrievePermitData(license_number, facility_id, faclityList)
		}, 300),
		[])

	const handleLicenceNumberChange = (e) => {
		const { value } = e.target
		if (value?.length > 6 && value?.length < 14) {
			if (value?.length != 9) {
				if (validLicenceNumber.test(value?.trim())) {
					const licenseData = {
						resident: 'Non-Resident',
						license_number: value?.toUpperCase()
					}
					setResident('Non-Resident')

					setFormData({ ...formData, ...licenseData })
				} else {
					const licenseData = {
						resident: '',
						license_number: value?.toUpperCase()
					}
					setFormData({ ...formData, ...licenseData })
					setResident('Invalid License Number')
				}
			} else {
				const alpha = value?.slice(0, 1)
				const number = value?.slice(1, 9)
				if (/^[H]+$/.test(alpha) && /(\d{8})/g.test(number)) {
					const licenseData = {
						resident: 'Resident',
						license_number: value?.toUpperCase()
					}
					setFormData({ ...formData, ...licenseData })
					setResident('Resident')
				} else {
					if (validLicenceNumber.test(value?.trim())) {
						const licenseData = {
							resident: 'Non-Resident',
							license_number: value?.toUpperCase()
						}
						setFormData({ ...formData, ...licenseData })
						setResident('Non-Resident')
					} else {
						const licenseData = {
							resident: '',
							license_number: value?.toUpperCase()
						}
						setFormData({ ...formData, ...licenseData })
						setResident('Invalid License Number')
					}
				}
			}
			// Call Debounce
			deb(value, formData?.facility_id)
		} else {
			const licenseData = {
				resident: '',
				license_number: value?.toUpperCase()
			}
			setFormData({ ...formData, ...licenseData })
			setResident('')
		}
	}

	const handleInputFieldsData = (e, i) => {

		const { name, value } = e.target
		// const payloadData = { ...formData }
		let vehicleList = selectedVehicleList?.slice() ?? []
		if (name === 'permit_category') {
			// PIMS-11105
			setIsDisplayFacility(false)
			// const facility_id = partnerDetails?.facilities?.[0]?.id
			// permitCategoryService(value, facility_id)
			permitCategoryService(value)
			const selectedCategory = permitCategory?.filter((item) => item?.id == value)
			formData.permit_category = value
			setFormData({ ...formData, permit_category: value, selectedCategory: selectedCategory?.[0] ? selectedCategory?.[0] : {}, is_hide_vehicle: selectedCategory?.[0]?.is_hide_vehicle == 1 ? true : false, is_hide_permit_service: selectedCategory?.[0]?.is_hide_permit_service == 1 ? true : false, is_hide_staff: selectedCategory?.[0]?.is_hide_staff == 1 ? true : false, user_type_id: '' })
			if (selectedCategory && selectedCategory?.length > 0) {
				if (selectedCategory?.[0]?.is_hide_permit_service && selectedCategory?.[0]?.is_hide_permit_service == 1) {
					setIsServiceDisabled(true)
				} else {
					setIsServiceDisabled(false)
				}
				if (selectedCategory?.[0]?.is_hide_vehicle && selectedCategory?.[0]?.is_hide_vehicle == 1) {
					setIsVehicleDisabled(true)
				} else {
					setIsVehicleDisabled(false)
				}
				if (selectedCategory?.[0]?.is_hide_staff && selectedCategory?.[0]?.is_hide_staff == 1) {
					setIsStaffDisabled(true)
				} else {
					setIsStaffDisabled(false)
				}
				if (selectedCategory?.[0]?.is_display_reason && selectedCategory?.[0]?.is_display_reason == 1) {
					setIsDisplayReason(true)
				} else {
					setIsDisplayReason(false)
				}
			}
			// setIsDisplayFacility(false)
			// const facility_id = partnerDetails?.facilities?.[0]?.id
			// permitCategoryService(value, facility_id)
		}
		if (name == 'color') {
			let modelData = vehicleDetailsList?.color?.filter((v) => v.name == value)
			vehicleList[i]['color'] = modelData?.[0]?.name
			vehicleList[i]['color_id'] = modelData?.[0]?.id
			setSelectedVehicleList(vehicleList)
		} else if (name == 'style') {
			let styleData = vehicleDetailsList?.style?.filter((v) => v.name == value)
			vehicleList[i]['style'] = styleData?.[0]?.name
			vehicleList[i]['style_id'] = styleData?.[0]?.id
			setSelectedVehicleList(vehicleList)
		} else if (name == 'vehicle_type') {
			let vehicletypeData = vehicleDetailsList?.vehicletype?.filter((v) => v.name == value)
			vehicleList[i]['vehicle_type'] = vehicletypeData?.[0]?.name ?? ''
			vehicleList[i]['vehicle_type_id'] = vehicletypeData?.[0]?.id ?? ''
			setSelectedVehicleList(vehicleList)
		} else if (name === 'license_plate' || name == 'modeltext' || name == 'maketext' || name == 'state_id' || name == 'country') {
			const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Access Permissions')
			const isAllowedCountry = (isPermissionExist(getAccessPermissionData, 'Partner Country Enabled')) //allow single country

			if (name === 'country' && !isAllowedCountry) {
				getStateByCountry(value, i)
			}
			if (name == 'state_id') {
				let stateData = formData?.multivehicleList?.[i]?.state && formData?.multivehicleList?.[i]?.state?.filter((v) => v?.id == value)
				vehicleList[i]['state_code'] = stateData?.[0]?.state_code
			}
			vehicleList[i][name] = value
			if (name === 'license_plate') {
				vehicleList[i][name] = restrictInValidCharLicense(value)?.replace(/[^a-zA-Z0-9]/g, '')
			} else {
				vehicleList[i][name] = value?.replace(/[^a-zA-Z0-9]/g, '')
			}
			setSelectedVehicleList(vehicleList)
		} else if (name === 'facility_id') {
			const selFaclity = faclityList?.filter((item) => item?.id == Number(value))
			setDocumentTypes([])
			setSelectedDocumentType(null)
			setEmployerDetails(createDefaultEmployerDetails(formData?.country))

			// Always update localStorage, selectedFacility, and formData as soon as there is a selection
			if (selFaclity?.[0]) {
				localStorage.setItem('facility', JSON.stringify(selFaclity?.[0]))
				setSelectedFacilty(selFaclity?.[0])
				setFormData(prev => ({
					...prev,
					'selFaclity': selFaclity?.[0],
					'facility_id': value,
					'permitNegotiate': selFaclity?.[0]?.is_permit_purchase_enabled == '0' ? '1' : '0'
				}))
				retrievePermitData(formData?.license_number, value, faclityList)
			} else {
				localStorage.setItem('facility', '{}')
				setSelectedFacilty(null)
				setFormData(prev => ({
					...prev,
					'selFaclity': null,
					'facility_id': value,
					'permitNegotiate': '0'
				}))
				setPermitRateError('')
			}

		} else if (name == 'permit_type') {
			handlePermitTypeChange(name, value)
		} else if (name === 'document_type') {
			const userSelectedDocumentType = documentTypes?.filter((item) => item?.document_key == value)
			setSelectedDocumentType(userSelectedDocumentType?.[0])
			setFormData({ ...formData, [name]: value })
		} else if (name == 'model') {
			vehicleList[i]['othermodel'] = (value == 'Others') ? true : false
			vehicleList[i][name] = value
			let modelData = vehicleModelList?.filter((v) => v.name == value)
			vehicleList[i]['model_id'] = modelData?.[0]?.id != 'Others' ? modelData?.[0]?.id : ''
			vehicleList[i]['modeltext'] = value == 'Others' ? '' : value
			setSelectedVehicleList(vehicleList)
		} else if (name == 'make') {
			let modelData = vehicleDetailsList?.make?.filter((v) => v?.name == value)
			let modelList = modelData?.[0]?.mst_model
			let makeData = vehicleMakeList?.filter((v) => v?.name == value)
			let check = modelList?.some((value) => value?.name == 'Others')
			if (!check && is_modal_show) {
				// If 'Others' is not in the list, add it to the first position
				modelList?.unshift({ 'id': 'Others', 'make_id': 'Others', 'name': 'Others' })
			} else {
				// If 'Others' exists, find and move it to the first index
				modelList = (modelList?.length > 0) ? modelList?.filter((value) => value?.name !== 'Others') : [] // Remove 'Others' from the list
				modelList.unshift({ 'id': 'Others', 'make_id': 'Others', 'name': 'Others' }) // Add it back at the first index
			}
			setvehicleModelList(modelList)
			//   setVehicleMakeID(value)
			vehicleList[i]['model_id'] = ''
			vehicleList[i]['model'] = value == 'Others' ? 'Others' : ''
			vehicleList[i]['modeltext'] = ''
			vehicleList[i]['vehicleList'] = modelList
			vehicleList[i]['make_id'] = makeData?.[0]?.id != 'Others' ? makeData?.[0]?.id : ''
			vehicleList[i][name] = value
			vehicleList[i]['maketext'] = value == 'Others' ? '' : value
			vehicleList[i]['othermake'] = (value == 'Others') ? true : false
			vehicleList[i]['othermodel'] = (value == 'Others') ? true : false
			vehicleList[i]['vehicleList'] = modelData?.[0]?.mst_model?.length > 0 ? modelData?.[0]?.mst_model : vehicleModelList

			setSelectedVehicleList(vehicleList)
		} else if (name == 'user_type_id') {
			setFormData({ ...formData, [name]: value?.replace(/[^a-zA-Z0-9]/g, '') })
		} else if (name == 'email') {
			setInvalidEmailPermit('')
			setFormData({ ...formData, [name]: value })
			validateEmail(value) && isPermissionExist(accessPermissions, 'Get Permit By Email') ? getPermitEmailID(value) : ''
		} else if (name == 'reserved_space_number') {
			if (!isNaN(value)) {
				setFormData({ ...formData, [name]: value })
			} else if (value.length == 1) {
				setFormData({ ...formData, [name]: '' })
			}
		} else {
			if (name == 'zone') {
				localStorage.setItem('zone', value)
			}
			setFormData({ ...formData, [name]: value })
		}
	}
	const getPermitEmailID = (value) => {
		const { user_type, id, partner_name } = partnerDetails

		const payload = {
			partner_id: user_type === '3' ? id : partner_name?.id || '',
			rm_id: user_type === '12' ? id : '',
			bussiness_id: user_type === '4' ? id : '',
			facility_id: formData?.facility_id,
			email_id: value,
		}

		dispatch(getPermitByEmail(payload)).then((res) => {
			if (res?.data && res?.data != null) {//Email vailidated true
				setInvalidEmailPermit('')
				setPermit(res?.data?.permit)
				if (res?.data?.permit?.length == 1) {
					formData.permit_list_data = res?.data?.permit
					setFormData({ ...formData, ...{ email: value, permit_type: res?.data?.permit?.[0]?.id }, 'permit_list_data': res?.data?.permit, 'permit_type_name': res?.data?.permit?.[0]?.name ? res?.data?.permit?.[0]?.name : '', permitService: [] })
				} else {
					formData.permit_list_data = res?.data?.permit
					setFormData({ ...formData, email: value, permit_list_data: res?.data?.permit, permitService: [] })
				}

			} else {
				const permitDetails = { email: value, permit_list_data: [], permit_rate: '', permit_rate_id: '', permit_type: '', selectedPermitType: [], permit_type_name: '' }

				setFormData({ ...formData, ...permitDetails })
				setPermit(EMPTY_ARRAY)
				setInvalidEmailPermit(res?.errors?.message ? res?.errors?.message : 'Please enter valid Email Id')
				// setFormError('home')


			}
		}).catch((err) => {
			setPermit([])
			setInvalidEmailPermit(err?.errors?.message ? err?.errors?.message : 'Please enter valid Email Id')

		})
	}
	const getStateByCountry = (value, i) => {
		setStateloader(i)
		setFormData({ ...formData, 'country': value })
		// ({ ...formData, ['city']: ''})
		let countryData = vehicleDetailsList?.country?.filter((v) => v.country_code == value)
		dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code, countryData?.[0]?.id)).then((res) => {
			setVehicleDetailsList(res)
			let multivehicle = [...multivehicleDetailsList]
			multivehicle.splice(i, 1, res)
			setMultivehicleDetailsList(multivehicle)
			setFormData({ ...formData, 'country': value, 'multivehicleList': multivehicle })
			setStateloader(null)

		}).catch(() => {
			setStateloader(null)
		})
		setCountryChange(false)

	}

	const retriveURLData = () => {
		if (searchParams?.size > 0) {
			const permitCategory = searchParams?.get('permitCategory')
			const permitType = searchParams?.get('permitType')
			if (permitCategory) {
				permitCategoryService(permitCategory)
			}
			if (permitCategory && permitType) {
				permitCategoryService(permitCategory)

			}


		}
	}

	const handlePermitTypeChange = (name, value) => {
		const selectedPermit = permitList?.filter((item) => item?.id == Number(value))

		let employerPermission = isPermissionExist(accessPermissions, 'Display Employer Details') &&
			formData?.selFaclity?.[0]?.facility_configuration?.permit_employer_name_enabled == '1' &&
			selectedPermit?.[0]?.permit_rate?.[0]?.is_employer == '1'

		if (!employerPermission) {
			setEmployerDetails(createDefaultEmployerDetails(formData?.country))
		}
		// setPermitTypes(selectedPermit)
		if (value) {
			setPermitTypes(selectedPermit)
			// const updatedData = { ...formData, ...selectedPermit?.[0], [name]: value, }
			// setFormData(updatedData)
			setDocumentTypes([])
			delete formData.document_type
			setMultiIdProof([])
			if (formData?.selFaclity?.facility_configuration?.permit_upload_docs_enabled == '1') {
				const updatedData = { ...formData, ...selectedPermit?.[0], [name]: value, 'permit_rate_id': selectedPermit?.[0]?.permit_rate?.[0]?.id, 'permit_type_name': selectedPermit?.[0]?.name ? selectedPermit?.[0]?.name : '' }
				retrieveDocumentsType(value, updatedData)
			}
		} else {
			const updatedData = {
				permit_rate: '',
				permit_rate_id: '',
				permit_type: '',
				selectedPermitType: '',
				permit_type_name: '',

			}
			setFormData({ ...formData, ...updatedData })
			setPermitPrices([])
			// setPermitTypes([])
		}


		// const updatedData = { ...formData, [name]: value, 'permit_rate': selectedPermit?.[0]?.permit_rate?.[0]?.rate, 'permit_rate_id': selectedPermit?.[0]?.permit_rate?.[0]?.id, 'permit_type_name': selectedPermit?.[0]?.name ? selectedPermit?.[0]?.name : '' }
		// const updatedData = { ...formData, selectedPermitType:selectedPermit, [name]: value, 'permit_rate': selectedPermit?.[0]?.permit_rate?.[0]?.rate, 'permit_rate_id': selectedPermit?.[0]?.permit_rate?.[0]?.id, 'permit_type_name': selectedPermit?.[0]?.name ? selectedPermit?.[0]?.name : '', 'permitService': [], 'permitServicePrice': 0, is_hide_vehicle: selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_vehicle == 1 ? true : false, is_hide_permit_service: selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_permit_service == 1 ? true : false, is_hide_staff: selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_staff == 1 ? true : false }
		// setFormData(updatedData)


	}

	const setPermitTypes = (selectedPermit) => {
		let vehicleListNew = [...vehicleListArray]
		if (selectedPermit && selectedPermit?.length > 0 && selectedPermit?.[0]?.permit_rate && selectedPermit?.[0]?.permit_rate?.length > 0) {
			// PIMS-11105
			if ((formData?.permitService && formData?.permitService?.length == 0) && selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_permit_service && selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_permit_service == 1) {
				// if (selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_permit_service && selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_permit_service == 1) {
				setIsServiceDisabled(true)
			} else {
				setIsServiceDisabled(false)
			}
			if (selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_vehicle && selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_vehicle == 1) {
				setIsVehicleDisabled(true)
				//hide and empty set vehicleList
				vehicleListNew = []
				vehicleListNew.push({ 'license_plate': '', 'make': '', 'model': '', 'color': '', 'country': formData?.country, 'state_id': '', 'othermake': false, 'othermodel': false, 'vehicleList': [] })
				setVehicleListArray(vehicleListNew)
			} else {
				setIsVehicleDisabled(false)
				setVehicleListArray(vehicleListLocal)
			}
			if (selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_staff && selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_staff == 1) {
				setIsStaffDisabled(true)
			} else {
				setIsStaffDisabled(false)
			}
			if (selectedPermit?.[0]?.permit_rate?.[0]?.is_display_reason && selectedPermit?.[0]?.permit_rate?.[0]?.is_display_reason == 1) {
				setIsDisplayReason(true)
			} else {
				setIsDisplayReason(false)
			}

			if (selectedPermit?.[0]?.permit_start_date && selectedPermit?.[0]?.permit_start_date != '') {
				let desiredStart_date = selectedPermit?.[0]?.permit_start_date ? moment(selectedPermit?.[0]?.permit_start_date).format('YYYY-MM-DD') : new Date()
				let desiredEnd_date = selectedPermit?.[0]?.permit_end_date ? moment(selectedPermit?.[0]?.permit_end_date).format('YYYY-MM-DD') : ''
				new Date(desiredStart_date) > new Date() ? setDesiredStartDate(new Date(desiredStart_date)) : setDesiredStartDate(new Date())
				new Date(desiredStart_date) > new Date() ? setDesiredMinStartDate(new Date(desiredStart_date)) : setDesiredMinStartDate(new Date())
				setDesiredEndDate(desiredEnd_date && desiredEnd_date != '' ? new Date(desiredEnd_date) : '')
			}

		}

		setResident(selectedPermit?.[0]?.name)
		const permit = selectedPermit?.[0]
		setPermitPrices(permit)
		const permitRate = permit?.permit_rate?.[0]
		if (permitRate?.name) {
			localStorage.setItem('permits', JSON.stringify(permitRate))
			let selectedService = formData?.permitServiceList
			let selectedPermitService = formData?.permitService ? formData?.permitService : []

			if (selectedPermit?.[0]?.show_carpool_service && selectedPermit?.[0]?.show_carpool_service == '1') {// check if permit byout then show only carpool 

				let permitService = formData?.permitServiceList

				selectedService = permitService?.filter((v) => v?.permit_service_name == 'Carpool Access')
				selectedPermitService = []
			} else {

				// selectedService = categoryServiceList //PIMS-11968
				selectedService = categoryServiceList && categoryServiceList?.length > 0 ? categoryServiceList : formData?.permitServiceList
				selectedPermitService = formData?.permitService ? formData?.permitService : []

			}
			const permitDetails = {
				desired_start_date: desiredStartDate,
				permitServiceList: selectedService,
				permit_rate: permitRate?.rate,
				permit_rate_id: permitRate?.id,
				facility_id: permitRate?.facility_id,
				license_number: formData?.license_number ? formData?.license_number : '',
				permit_type: selectedPermit?.[0]?.id,
				selectedPermitType: selectedPermit,
				permit_type_name: selectedPermit?.[0]?.name ? selectedPermit?.[0]?.name : '',
				permitService: selectedPermitService, // PIMS-11317 Reset the permit service on the bases of change permit type
				// permitService: formData?.permitService ? formData?.permitService : [],
				permitServicePrice: formData?.permitServicePrice ? formData?.permitServicePrice : 0, //PIMS-11105
				// permitServicePrice: 0,
				is_hide_vehicle: selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_vehicle == 1 ? true : false,
				is_hide_permit_service: selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_permit_service == 1 ? true : false,
				is_hide_staff: selectedPermit?.[0]?.permit_rate?.[0]?.is_hide_staff == 1 ? true : false,
				is_display_reason: selectedPermit?.[0]?.permit_rate?.[0]?.is_display_reason == 1 ? true : false,
				// user_type_id: ''
				user_type_id: formData?.user_type_id ? formData?.user_type_id : '',
				vehicleList: vehicleListNew,
			}
			setFormData({ ...formData, ...permitDetails })
			setPermitRateError('')
		} else {
			if (formData?.facility_id) {
				setPermitRateError('')
			} else {
				setPermitRateError('')
			}
			localStorage.setItem('permits', '{}')
		}
	}

	const updateMultivehicleList = (existingList, newItem, vehicleCount) => {
		const updatedList = [...existingList]
		if (vehicleCount > 0) {
			const indexAdd = existingList.length + 1
			updatedList.splice(indexAdd, 0, newItem)
		} else {
			updatedList.push(newItem)
		}
		return updatedList
	}

	const canAddVehicle = (vehicleList = []) => {
		const allFilled = vehicleList.every(item => item?.license_plate !== '')
		const newVehicleAdded = vehicleList?.filter(item => !item?.id) // Check if the vehicle being added doesn't have an ID (new vehicle)
		const limitExceeded = isVehicleLimitExceeded(accessPermissions, (vehicleListArray.length + newVehicleAdded.length), partnerDetails?.max_vehicle)
		return { allFilled, limitExceeded }
	}

	const addVehicle = () => {
		const vehicleList = selectedVehicleList?.slice() ?? []
		const { allFilled, limitExceeded } = canAddVehicle(vehicleList)

		if (!limitExceeded && allFilled) {
			const defaultVehicle = createDefaultVehicle(formData?.country, is_modal_show)
			const selectedVehicleList = [...vehicleList, defaultVehicle]

			const updatedMultivehicleList = updateMultivehicleList(multivehicleDetailsList, vehicleDetailsList, vehicleCount)
			setMultivehicleDetailsList(updatedMultivehicleList)

			setSelectedVehicleList(selectedVehicleList)
			setFormData({
				...formData,
				multivehicleList: updatedMultivehicleList
			})

			setError('')
		} else if (!allFilled) {
			setError('Please enter the License plate, before adding a new vehicle!')
		}
	}

	const removeVehicleMake = (e, i) => {
		const updatedList = selectedVehicleList?.slice() ?? []
		const removedVehicle = updatedList[i]

		// Check if this vehicle is in vehicleCountList (based on ID)
		const wasCounted = vehicleCountList?.some(val => val?.id == removedVehicle?.id)
		if (wasCounted) {
			setvehicleCount(prev => prev - 1)
		}

		// Remove the vehicle at index `i`
		updatedList.splice(i, 1)
		const { allFilled } = canAddVehicle(updatedList)
		if (allFilled) {
			setError('')
		}

		setSelectedVehicleList(updatedList)

		// Optionally: hide table if no vehicles remain
		// if (updatedList.length === 0) {
		//   setIsVehicleTableVisible(false)
		// }
	}

	const onSelect = (selectedList, selectedItem) => {
		let newSelectedList = selectedList
		let permitServiceRates = 0
		if (selectedItem?.permit_service_name == 'Select All Access') {
			newSelectedList = formData?.permitServiceList
			// permitServiceRates = selectedItem?.permit_service_rate
			//calculate rate
			let selectedListData = newSelectedList?.filter((v) => v?.permit_service_name !== 'Select All Access')
			selectedListData?.length > 0 && selectedListData.map((v) => {
				permitServiceRates = Number(permitServiceRates) + Number(v?.permit_service_rate)
			})

		} else {
			newSelectedList.map((v) => {
				permitServiceRates = Number(permitServiceRates) + Number(v?.permit_service_rate)
			})

		}
		// setPermitServiceForm(newSelectedList)
		// setPermitServiceRate(permitServiceRates)

		let Negotiatepayment = 0
		let checkNegotiatepayment = newSelectedList?.filter((v) => v?.is_purchase == '0')
		// if(checkNegotiatepayment.length>0){
		// let checkNegotiatepayment = selectedList.filter((v)=>v.negotiate=='1')
		if (checkNegotiatepayment?.length > 0 || selectedFaclity?.is_permit_purchase_enabled == '0') {
			Negotiatepayment = 1
		}

		if (newSelectedList?.some(item => item?.display_facility == 1)) {
			setIsDisplayFacility(true)


			const param = {
				services: newSelectedList?.map((item) => item?.id)?.toString(),
				permittype: formData?.permit_type || '',//PIMS-11965
			}
			dispatch(getFacilityList(partner, param)).then((res) => {
				setFaclityList(res)
			})
			formData.facility_id = ''
			setFormData(formData)
		} else {
			setIsDisplayFacility(false)
		}

		setFormData({
			...formData, 'permitService': newSelectedList, 'permitServicePrice': permitServiceRates, 'permitNegotiate': Negotiatepayment
		})
	}

	const onRemove = (selectedList, removedItem) => {

		let newSelectedList = selectedList
		let permitServiceRates = 0

		if (removedItem?.permit_service_name == 'Select All Access') {
			newSelectedList = []
		} else {
			newSelectedList = newSelectedList?.filter((v) => v?.permit_service_name !== 'Select All Access')

			newSelectedList?.length > 0 && newSelectedList.map((v) => {
				permitServiceRates = Number(permitServiceRates) + Number(v?.permit_service_rate)
			})
		}

		let Negotiatepayment = 0
		let checkNegotiatepayment = newSelectedList?.filter((v) => v?.is_purchase == '0')
		if (checkNegotiatepayment?.length > 0 || selectedFaclity?.is_permit_purchase_enabled == '0') {
			Negotiatepayment = 1
		}
		setFormData({ ...formData, 'permitService': newSelectedList, 'permitServicePrice': permitServiceRates, 'permitNegotiate': Negotiatepayment })
		// PIMS-11105

		if (newSelectedList?.some(item => item?.display_facility == 1)) {
			setIsDisplayFacility(true)

			const param = {
				services: newSelectedList?.map((item) => item?.id)?.toString(),
				permittype: formData?.permit_type || '',
			}
			dispatch(getFacilityList(partner, param)).then((res) => {
				setFaclityList(res)
				formData.facility_id = ''
				setFormData({ ...formData, 'permitService': newSelectedList, 'permitServicePrice': permitServiceRates, 'permitNegotiate': Negotiatepayment })
			})

		} else {
			setIsDisplayFacility(false)
			const updatedData = {
				// permit_rate: '',
				// permit_rate_id: '',
				// permit_type: '',
				// selectedPermitType: '',
				// permitPrices: [],
				// permit_type_name: '',
				permitService: newSelectedList,
				permitServicePrice: permitServiceRates,
				permitNegotiate: Negotiatepayment,
				selFaclity: partnerDetails?.facilities?.[0]
			}
			const formDataUpdate = { ...formData, ...updatedData }

			setFormData(formDataUpdate)
			// setPermitPrices([])
			// permitCategoryService(formData?.permit_category, partnerDetails?.facilities?.[0]?.id)
		}

	}

	const handleEntryTime = (event) => {
		setDesiredStartDate(event)
		setFormData({ ...formData, 'desired_start_date': event })
	}



	const onVehicleListChange = (selectedList, changedObject) => {
		const currentList = selectedVehicleList?.slice() ?? []
		// CASE 1: Select All / Clear All
		if (!changedObject) {
			// Make sure all selectedList items have valid IDs
			const hasOnlyValidIds = selectedList?.every(v => v?.id !== undefined && v?.id !== null)
			if (!hasOnlyValidIds) return

			const selectedIds = selectedList?.map(v => v?.id)
			const updatedList = currentList?.filter(v => !v?.id || selectedIds?.includes(v?.id))

			// Add any newly selected items not already in currentList
			selectedList?.forEach(v => {
				if (!currentList?.some(c => c.id === v.id)) {
					updatedList.push(v)
				}
			})

			// Sort by id (only for items with id)
			const withId = updatedList.filter(v => v.id !== undefined && v.id !== null)
			const withoutId = updatedList.filter(v => v.id === undefined || v.id === null)

			withId.sort((a, b) => a.id - b.id)
			const finalList = [...withId, ...withoutId]

			setSelectedVehicleList(finalList)
			return
		}

		// Case 2: Single select/deselect
		if (!changedObject?.id) return

		const exists = currentList.some(v => v.id === changedObject.id)

		const updatedList = exists
			? currentList.filter(v => v.id !== changedObject.id) // remove
			: [...currentList, changedObject]                   // add

		// Separate objects with and without id
		const withId = updatedList.filter(v => v.id !== undefined && v.id !== null)
		const withoutId = updatedList.filter(v => v.id === undefined || v.id === null)

		withId.sort((a, b) => a.id - b.id)

		const finalList = [...withId, ...withoutId]

		setSelectedVehicleList(finalList)
	}

	const DisplayField = (label, value) => {
		return <div className="col-6">
			<label className="floatLabel">{label}</label>
			<div className="inputBox">{value || '-'}</div>
		</div>
	}

	const LicensePlateInput = (vehicleListItem, vehicleListIndex, isMobileView = false) => {
		return <div className={`${isMobileView ? 'col-6' : isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? 'col-3' : ''}`}>
			<TextInput
				label={isMobileView ? 'License Plate' : ''}
				type="text"
				name='license_plate'
				className="form-control form-control-sm"
				placeholder="License Plate"
				maxLength={10}
				minLength={1}
				value={vehicleListItem?.license_plate}
				onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
				aria-describedby="licenseplate"
				spaceNotAllowed={true}
				required={true}
			/>
			<span className="form-text small text-danger">{formError == 'home' && !selectedVehicleList?.[vehicleListIndex]?.license_plate != '' ? 'This field is required' : (selectedVehicleList?.[vehicleListIndex]?.license_plate != '' && selectedVehicleList?.[vehicleListIndex]?.license_plate.length < 2) ? 'Minimum 2 characters allowed' : ''}</span>
		</div>
	}

	const MakeInput = (vehicleListItem, vehicleListIndex, isMobileView = false) => {
		return <div className={`${isMobileView ? 'col-6' : ''}`}>
			{isMobileView && <label htmlFor="make">Make</label>}
			{vehicleListItem?.othermake ? <div className="position-relative">
				<input
					type="text"
					name='maketext'
					label="Make"
					className="form-control form-control-sm"
					placeholder="Make"
					required={true}
					onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
					maxLength={15}
					minLength={0}
					onKeyDown={restrictSpecialChar}
					value={vehicleListItem?.maketext}
					aria-describedby="color" />
				<i
					className='fa fa-times position-absolute top-50 end-0 translate-middle-y me-2'
					onClick={() => {
						const vehicleList = [...selectedVehicleList]
						vehicleList[vehicleListIndex]['model_id'] = ''
						vehicleList[vehicleListIndex]['model'] = ''
						vehicleList[vehicleListIndex]['modeltext'] = ''
						vehicleList[vehicleListIndex]['vehicleList'] = []
						vehicleList[vehicleListIndex]['make_id'] = ''
						vehicleList[vehicleListIndex]['make'] = ''
						vehicleList[vehicleListIndex]['maketext'] = ''
						vehicleList[vehicleListIndex]['othermake'] = false
						vehicleList[vehicleListIndex]['othermodel'] = false
						setSelectedVehicleList(vehicleList)
					}}
				></i>
			</div> :
				<select autoComplete="off" name="make" placeholder="Make" onKeyDown={restrictSpecialChar} className="form-select form-select-sm" value={vehicleListItem?.make} id="make" onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}>
					<option value="">Select Make</option>
					{(vehicleMakeList?.length > 0) && vehicleMakeList?.map((val, index) => {
						return (
							<option value={val?.name} key={index} >{val?.name}</option>
						)
					})}
				</select>}
		</div>
	}

	const ModelInput = (vehicleListItem, vehicleListIndex, isMobileView = false) => {
		return <div className={`${isMobileView ? 'col-6' : ''}`}>
			{isMobileView && <label htmlFor="model">Model</label>}
			{(vehicleListItem?.othermake || vehicleListItem?.othermodel) ? <div className="position-relative">
				<input
					type="text"
					name='modeltext'
					className="form-control form-control-sm"
					placeholder="Model"
					onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}
					maxLength={15}
					minLength={4}
					onKeyDown={restrictSpecialChar}
					value={vehicleListItem?.modeltext}
					aria-describedby="model" />
				{!vehicleListItem?.othermake ? <i
					className='fa fa-times position-absolute top-50 end-0 translate-middle-y me-2'
					onClick={() => {
						const vehicleList = [...selectedVehicleList]
						vehicleList[vehicleListIndex]['othermodel'] = false
						vehicleList[vehicleListIndex]['model'] = ''
						vehicleList[vehicleListIndex]['model_id'] = ''
						vehicleList[vehicleListIndex]['modeltext'] = ''
						setSelectedVehicleList(vehicleList)
					}}
				></i> : null}
			</div> :
				<select className='form-select form-select-sm' value={vehicleListItem?.model} placeholder="Model" name="model" id='model' onKeyDown={restrictSpecialChar} onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} disabled={vehicleListItem?.make ? false : true}>
					<option value="0">Select an option</option>
					{(vehicleListItem?.vehicleList?.length > 0) && vehicleListItem?.vehicleList?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
				</select>
			}
		</div>
	}

	const VehicleTypeInput = (vehicleListItem, vehicleListIndex, isMobileView = false) => {
		return <div className={`${isMobileView ? 'col-6' : ''}`}>
			{isMobileView && <label htmlFor="vehicle_type">Vehicle Type <span className='text-danger'>*</span></label>}
			<select name='vehicle_type' autoComplete="off" className='form-select form-select-sm' value={vehicleListItem?.vehicle_type} placeholder="vehicle_type" id='vehicle_type' onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
				<option value="">Select an option</option>
				{(vehicleDetailsList?.vehicletype?.length > 0) && vehicleDetailsList?.vehicletype?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
			</select>
			<span className="form-text small text-danger">{formError == 'home' && !selectedVehicleList?.[vehicleListIndex]?.vehicle_type != '' ? 'This field is required' : ''}</span>
		</div>
	}

	const ColorInput = (vehicleListItem, vehicleListIndex, isMobileView = false) => {
		return <div className={`${isMobileView ? 'col-6' : ''}`}>
			{isMobileView && <label htmlFor="color">Color</label>}
			<select name='color' autoComplete="off" className='form-select form-select-sm' value={vehicleListItem?.color} placeholder="Color" id='color' onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
				<option value="">Select an option</option>
				{(vehicleDetailsList?.color?.length > 0) && vehicleDetailsList?.color?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
			</select>
		</div>
	}

	const StyleInput = (vehicleListItem, vehicleListIndex, isMobileView = false) => {
		return <div className={`${isMobileView ? 'col-6' : ''}`}>
			{isMobileView && <label htmlFor="style">Style</label>}
			<select name='style' autoComplete="off" className='form-select form-select-sm' value={vehicleListItem?.style} placeholder="Style" id='style' onChange={(e) => handleInputFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
				<option value="">Select an option</option>
				{(vehicleDetailsList?.style?.length > 0) && vehicleDetailsList?.style?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
			</select>
		</div>
	}

	const CountryInput = (vehicleListItem, vehicleListIndex, isMobileView = false) => {
		return <div className={`${isMobileView ? 'col-6' : ''}`}>
			{isMobileView && <label htmlFor="country">Country</label>}
			<select className='form-select form-select-sm' value={vehicleListItem?.country} placeholder="Country" name="country" id='country' onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}>
				<option value="0">Select an option</option>
				{(formData?.multivehicleList?.[vehicleListIndex]?.country?.length > 0) && formData?.multivehicleList?.[vehicleListIndex]?.country?.map((item, itemIndex) => {
					if (item?.country_code == 'US' || item?.country_code == 'CA' || item?.country_code == 'GB') {
						return <option key={(itemIndex + 1)} value={item?.country_code} selected={item?.country_code == selectedVehicleList?.[vehicleListIndex]?.country}>{item?.name}</option>
					}
				}
				)}
			</select>
		</div>
	}

	const StateInput = (vehicleListItem, vehicleListIndex, isMobileView = false) => {
		return <div className={`${isMobileView ? 'col-6' : ''}`}>
			{isMobileView && <label htmlFor="state_id">State</label>}
			{(stateloader == vehicleListIndex) ? <div className="form-control form-control-sm">
				<Circles
					height="15"
					width="15"
					color="var(--bs-primary)"
					ariaLabel="circles-loading"
					visible={true}
				/>
			</div> : <select className='form-select form-select-sm' value={vehicleListItem?.state_id} placeholder="State" name="state_id" id='state_id' onKeyDown={restrictSpecialChar} onChange={(e) => handleInputFieldsData(e, vehicleListIndex)}>
				<option value="0">Select an option</option>
				{(formData?.multivehicleList?.[vehicleListIndex]?.state?.length > 0) && formData?.multivehicleList?.[vehicleListIndex]?.state?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id} selected={item?.id == selectedVehicleList?.[vehicleListIndex]?.state_id}>{item?.state_code}</option>)}
			</select>}
		</div>
	}


	const mobileViewVehicleSection = () => {
		return <div className=' '>
			{selectedVehicleList?.map((vehicleListItem, vehicleListIndex) => {
				if (vehicleListItem?.id) {
					return <div key={vehicleListIndex} className="row bg-light g-1 p-1 mt-3">
						{DisplayField('License Plate', vehicleListItem?.license_plate || '-')}
						{isPermissionExist(accessPermissions, 'Get Vehicle Type') ? DisplayField('Vehicle Type', vehicleListItem?.vehicle_type || '-') : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : DisplayField('Make', vehicleListItem?.make || '-')}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : is_modal_show ? DisplayField('Model', vehicleListItem?.model || '-') : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : DisplayField('Color', vehicleListItem?.color || '-')}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Get Permit By Email') ? DisplayField('Style', vehicleListItem?.style || '-') : null}

						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? DisplayField('Country', vehicleListItem?.country || '-') : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : DisplayField('State', vehicleListItem?.state_code || '-')}
						<div className='col-6 d-flex justify-content-end align-items-end'>
							<a type="button" className="small p-1 border-none text-danger text-white"
								onClick={(e) => removeVehicleMake(e, vehicleListIndex)}
							><i className='fa fa-trash'></i></a>
						</div>
					</div>
				} else {
					return <div key={vehicleListIndex} className="row bg-light g-1 p-1 mt-3">
						{LicensePlateInput(vehicleListItem, vehicleListIndex, true)}
						{isPermissionExist(accessPermissions, 'Get Vehicle Type') ? VehicleTypeInput(vehicleListItem, vehicleListIndex, true) : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : MakeInput(vehicleListItem, vehicleListIndex, true)}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : is_modal_show ? ModelInput(vehicleListItem, vehicleListIndex, true) : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : ColorInput(vehicleListItem, vehicleListIndex, true)}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Get Permit By Email') ? StyleInput(vehicleListItem, vehicleListIndex, true) : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? CountryInput(vehicleListItem, vehicleListIndex, true) : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : StateInput(vehicleListItem, vehicleListIndex, true)}
						{selectedVehicleList?.length > 1 ? <div className='col-6 d-flex justify-content-end align-items-end'>
							<a type="button" className="small p-1 border-none text-danger text-white" onClick={(e) => removeVehicleMake(e, vehicleListIndex)}><i className='fa fa-trash'></i></a>
						</div> : null}
					</div>
				}
			})}
		</div>
	}

	const deskTopViewVehicleSection = () => {
		return <div className='table-responsive d-none d-sm-block'>
			<table className={`table mt-2 border table-borderless table-striped table-sm mb-0 small-first-col ${selectedVehicleList?.length > 5 ? 'table-scroll' : ''}`}>
				<thead className='table-light'>
					<tr>
						<th className='small text-muted'>License Plate <span className='text-danger'>*</span></th>
						{isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <th className='small text-muted'>Vehicle Type <span className='text-danger'>*</span></th> : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : <th className='small text-muted'>Make</th>}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : is_modal_show ? <th className='small text-muted'>Model</th> : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : <th className='small text-muted'>Color</th>}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Get Permit By Email') ? <th className='small text-muted'>Style</th> : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? <th className='small text-muted'>Country</th> : null}
						{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : <th className='small text-muted'>State/Province</th>}
						{selectedVehicleList?.length > 1 ? <th className='small text-muted action-column'>Action</th> : null}
					</tr>
				</thead>
				<tbody className='body-half-screen'>
					{selectedVehicleList?.map((vehicleListItem, vehicleListIndex) => {
						if (vehicleListItem?.id) {
							return (
								<tr key={vehicleListIndex}>
									<td className='small'>{vehicleListItem?.license_plate || '-'}</td>
									{isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <td className='small'>{vehicleListItem?.vehicle_type || '-'}</td> : null}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : <td className='small'>{vehicleListItem?.make || '-'}</td>}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : is_modal_show ? <td className='small'>{vehicleListItem?.model || '-'}</td> : null}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : <td className='small' >{vehicleListItem?.color || '-'}</td>}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Get Permit By Email') ? <td className='small'>
										{vehicleListItem?.style || '-'}
									</td> : null}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? <td className='small'>{vehicleListItem?.country || '-'}</td> : null}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : <td className='small'>{vehicleListItem?.state_code || '-'}</td>}
									<td className='small action-column'>
										<a type="button" className="small p-1 border-none text-danger text-white"
											onClick={(e) => removeVehicleMake(e, vehicleListIndex)}
										><i className='fa fa-trash'></i></a>
									</td>
								</tr>
							)
						} else {
							return (
								<tr key={vehicleListIndex} className='bg-light border'>
									<td>{LicensePlateInput(vehicleListItem, vehicleListIndex)}</td>
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <td>{VehicleTypeInput(vehicleListItem, vehicleListIndex)}</td> : null}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : <td>{MakeInput(vehicleListItem, vehicleListIndex)}</td>}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : is_modal_show ? <td>{ModelInput(vehicleListItem, vehicleListIndex)}</td> : null}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : <td>{ColorInput(vehicleListItem, vehicleListIndex)}</td>}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Get Permit By Email') ? <td>{StyleInput(vehicleListItem, vehicleListIndex)}</td> : null}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? <td>{CountryInput(vehicleListItem, vehicleListIndex)}</td> : null}
									{isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : <td>{StateInput(vehicleListItem, vehicleListIndex)}</td>}
									{selectedVehicleList?.length > 1 ? <td className='action-column'>
										<a type="button" className="small p-1 border-none text-danger text-white" onClick={(e) => removeVehicleMake(e, vehicleListIndex)}><i className='fa fa-trash'></i></a>
									</td> : null}
								</tr>
							)
						}
					})}
				</tbody>

			</table>
		</div>
	}

	const handleDeleteDocument = (item) => {
		const filteredDocuments = idMultiProof?.filter((idProofItem) => idProofItem?.type != item?.type)
		setMultiIdProof([...filteredDocuments])
	}

	const retrieveDocumentsType = (facilityId = '', updatedData) => {
		setFetchingDocumentTypes(true)
		delete updatedData.document_type
		dispatch(getDocumentTypes(facilityId)).then((res) => {
			setFetchingDocumentTypes(false)
			if (res && res?.length > 0) {
				setSelectedDocumentType(res?.[0])
				// const documentAddedFormData = { ...updatedData, ['document_type']: res?.[0]?.document_key }
				// setFormData(documentAddedFormData)

				setDocumentTypes(res)
			} else {
				setDocumentTypes([])
				setSelectedDocumentType(null)
			}
		}).catch(() => {
			setFetchingDocumentTypes(false)
			setDocumentTypes([])
			setSelectedDocumentType(null)
		})
	}

	const handleEmployerDetailsChange = (key, value) => {
		setEmployerDetails((prevDetails) => ({
			...prevDetails,
			[key]: value
		}))
	}

	return (
		<div className='home-container'>
			<h4 className="text-center my-4 fw-bolder">Basic Information</h4>
			{isPermissionExist(accessPermissions, 'Permit Services Rule') ?
				partner == 'usm' || partner == 'usmparking' ?
					<div className='alert position-relative alert-info border-info'>
						<div>
							<p className='mb-1 m-0 fw-bold'><a href='https://usm.maine.edu/parking-services/' target='_blank' rel="noopener noreferrer" style={{ color: 'blue' }} className="small m-0"><i className='fa fa-link me-2'></i>Click For: Access Options/Where to Park/Rules </a></p>

							<p className='small mb-1' ><b>OPTIONAL Permit Services:</b></p>
							<p className='small mb-1' ><b>Students:</b> Commuters and Gorham Resident permits are $0. PC students pay out of pocket. If selecting optional permit services - the reserved or all access is an additional charge. <a className='btn btn-sm align-items-center d-inline-flex gap-3 py-1 justify-content-between  fw-bold ' onClick={() => setRuleOpen(!ruleOpen)} data-bs-toggle="collapse" href="#hiddenSection" role="button" aria-expanded="false" aria-controls="hiddenSection">READ your permit rules before selecting <i className={ruleOpen ? 'fa fa-square-minus' : 'fa fa-square-plus'}></i></a> </p>

							<div className="collapse" id="hiddenSection">
								<p className='small mb-1' >

									<ul>
										<li>Commuters: may only have a business hours reserved space in garage 1</li>
										<li>First Year Gorham Resident:  may have a business hours reserved space in garage 1 or, business or 24x7, in your residential lot. </li>
										<li>Upper Class Gorham Resident: may have a business hours reserved space in garage 1 or, business or 24x7, in your residential lot.</li>
										<li>Portland Commons Resident: may only have a reserved space in Garage 2 (business or 24x7) and on the Gorham campus business hours only.</li>
										<li>Email <b>usmparkingservices@maine.edu </b>with your preferred lot in Gorham. If your permit does not allow parking in that lot or certain hours, the request will be denied. Ensure you read your rules before emailing. </li>
										<li>For those looking to sign up for use of the convenient carpooling-only spaces, follow these directions. If you want to carpool with your vehicle at least some of the time, select “Carpool access” as one of the available services under “Permit Services.” If you want to carpool, but dont have a vehicle, then select “Rider only” under “Permit Type.” Upon completing this registration, you will need to print your parking permit # and QR code and put it on display on your dashboard when parking in a carpool-only space. Two printed permits/passes belonging to two individuals are required to be displayed in the vehicle to comply. For more detailed instructions, please visit: <a href='https://usm.maine.edu/parking-transportation/carpool/'>https://usm.maine.edu/parking-transportation/carpool/</a></li>
									</ul>
								</p>
							</div>
							<p className='small mb-1' ><b>Reserved Space:</b> A reserved space is optional and is an additional charge. business hours is 7am-3pm reserved just for your car. 24x7 is reserved just for your car at all times. Parking Services will review for approval and email you. </p>

							<p className='small m-0' ><b>All Access:</b> The all access option allows parking on any campus, 24hrs/day in garages, and lots. Beyond your permit rules.  (P8 and GC1 are no parking areas).  </p>

						</div>
					</div> :
					(partnerDetails?.brand_setting?.permit_terms_condition_content && partnerDetails?.brand_setting?.permit_terms_condition_content != '') || (selectedFaclity?.facility_configuration?.permit_terms_condition_content && selectedFaclity?.facility_configuration?.permit_terms_condition_content != '') ?
						<div className="alert position-relative alert-info border-info">
							{isOverflowing ? <div className='d-flex justify-content-end'>

								<button
									type="button"
									className="btn btn-link p-0 mt-2 small pTnC-toggle-btn"
									onClick={() => setExpanded((prev) => !prev)}
								>
									{expanded ? 'Show less ▲' : 'Show more ▼'}
								</button>

							</div> : null}
							<div
								ref={contentRef}
								className={`pTnC-collapsible-content ${expanded ? 'expanded' : 'collapsed'}`}
							>
								<div dangerouslySetInnerHTML={{
									__html: (selectedFaclity?.facility_configuration?.permit_terms_condition_content && selectedFaclity?.facility_configuration?.permit_terms_condition_content != '') ? selectedFaclity?.facility_configuration?.permit_terms_condition_content :
										partnerDetails?.brand_setting?.permit_terms_condition_content
								}} />

								{!expanded && isOverflowing && <div className='pTnC-fade-overlay'></div>}
							</div>
						</div> : null
				:
				partner == 'unitedparking' ?
					<div className='alert position-relative alert-info border-info'>
						<div>

							<div dangerouslySetInnerHTML={{
								__html: (selectedFaclity?.facility_configuration?.permit_terms_condition_content && selectedFaclity?.facility_configuration?.permit_terms_condition_content != '') ? selectedFaclity?.facility_configuration?.permit_terms_condition_content :
									partnerDetails?.brand_setting?.permit_terms_condition_content
							}} />
							{/* {partnerDetails?.brand_setting?.external_terms_condition_doc && partnerDetails?.brand_setting?.external_terms_condition_doc_url ? <p className='mb-1 m-0 fw-bold'><a href={partnerDetails?.brand_setting?.external_terms_condition_doc_url} target='_blank' rel="noopener noreferrer" style={{ color: 'blue' }} className="small m-0"><i className='fa fa-link me-2'></i>Read the full Terms & Conditions here</a></p> : null} */}
						</div>
					</div> : null}

			<div className="row g-2">
				{isPermissionExist(accessPermissions, 'Hide Facility') ? null :
					<div className={partner == 'demo-parkengage' ? 'col-sm-3' : isPermissionExist(accessPermissions, 'Permit Category') ? 'col-sm-4' : 'col-sm-4'}>
						<div className="mb-2 position-relative">
							<label className="form-label">Parking Location <span className='text-danger'> *</span></label>
							<select name="facility_id" id="facility_id" className="form-select" onChange={e => {
								handleInputFieldsData(e)

								// start: select hone par selectedFacility (ref) update and localStorage update
								const selectedId = e.target.value
								const selected = faclityList?.find(f => String(f.id) === String(selectedId))
								if (selected) {
									setSelectedFacilty(selected) // for state/ref update
									localStorage.setItem('facility', JSON.stringify(selected))
								} else {
									setSelectedFacilty(null)
									localStorage.setItem('facility', '{}')
								}
								// end
							}}
								disabled={faclityList?.length < 1 || searchParams?.get('permitID')}
								value={formData?.facility_id || ''}
							>
								<option value="">Select Parking Location</option>
								{faclityList?.map((faclityListItem, faclityListIndex) => {
									return (
										<option value={faclityListItem?.id} key={faclityListIndex}>
											{faclityListItem?.full_name}
										</option>
									)
								})}
							</select>
							{!loader ? <span className='text-end small d-block mb-1'>
								<span className="form-text text-danger">{permitRateError ? permitRateError : ''}
								</span>
							</span> : null}
							<span className="form-text text-danger">{formError == 'home' && !formData?.facility_id ? 'This field is required' : ''}</span>
						</div>
					</div>}
				{partner == 'demo-parkengage' ? <div className="col-sm-3">
					<div className="mb-2 position-relative">
						<label className="form-label">Select Zone</label>
						<select name="zone" id="zone" className="form-select" onChange={handleInputFieldsData} >
							{/* <option value={faclityList[0]?.id} selected={formData?.zone == faclityList[0]?.id}>{faclityList[0]?.full_name}</option> */}

							{zoneList?.map((zoneListItem, index) => {
								return (
									<option key={index} value={zoneListItem?.val} selected={formData?.zone == zoneListItem?.val}>{zoneListItem?.name}</option>
								)
							})}
						</select>
					</div>


				</div> : null}
				{isPermissionExist(accessPermissions, 'Permit Category') ?
					<div className={'col-sm-4'}>
						<div className="mb-2 position-relative">
							<label className="form-label">Permit Category<span className='text-danger'> *</span></label>
							{categoryURL && !formData?.permit_category ? <div className="form-select"><Circles
								height="15"
								width="15"
								color="var(--bs-primary)"
								ariaLabel="circles-loading"
								visible={true}
							/></div> : <select disabled={categoryURL && formData?.permit_category} name="permit_category" id="permit_category" className="form-select" onChange={handleInputFieldsData}>
								<option value=''>Select Permit Category</option>

								{permitCategory?.map((permitCategoryValue, index) => {
									return (
										<option value={permitCategoryValue?.id} selected={formData?.permit_category == permitCategoryValue?.id} key={index}>{permitCategoryValue?.permit_type_name}</option>
									)
								})}
							</select>}

							<span className="form-text text-danger">{formError == 'home' && !formData?.permit_category ? 'This field is required' : ''}</span>
						</div>
					</div> : null}
				{isPermissionExist(accessPermissions, 'Get Permit By Email') && <div className="col-sm-4 col">
					<div className="mb-2 position-relative">
						<label className="form-label">Email <span className='text-danger'> *</span></label><input
							className="form-control "
							maxLength={100}
							disabled={(isLoggedIn && loginData?.email) ? true : false}
							minLength={1}
							name="email" placeholder="Email" required="" type="email"
							value={formData?.email ? formData?.email : loginData?.email ? loginData?.email : ''}
							onChange={handleInputFieldsData}
							pattern="^[^@]+@[^@]+.[a-zA-Z]{2,6}" />
						<span className="form-text text-danger h-40">{invalidEmailPermit && invalidEmailPermit != '' ? invalidEmailPermit : ''}</span>
						<span className="form-text text-danger h-40">{formError == 'home' ? !formData?.email ? 'This field is required' : !validateEmail(formData?.email, formData?.selectedCategory, formData?.selectedPermitType?.[0]) ? (formData?.selectedCategory?.email_domain_validation == 1 || formData?.selectedPermitType?.[0]?.email_domain_validation == 1) ? 'Please use a valid university email id' : 'Please enter a valid email id' : '' : ''}</span>
					</div>
				</div>}
				<div className="col-sm-4 col">
					<div className="mb-2 position-relative">
						<label className="form-label">Permit Type <span className='text-danger'> *</span></label>
						{((categoryURL && !formData?.permit_category) || categoryLoader) && permitList?.length == 0 ? <div className="form-select"><Circles
							height="15"
							width="15"
							color="var(--bs-primary)"
							ariaLabel="circles-loading"
							visible={true}
						/></div> : <select disabled={categoryURL && formData?.permit_type} name="permit_type" id="permit_type" className="form-select" onChange={(e) => handleInputFieldsData(e, '')} >
							<option value={''}>Select Permit Type</option>
							{permitList?.map((permit, index) => {
								return (
									<option key={index} value={permit?.id} selected={formData?.permit_type == permit?.id}>{permit?.permit_rate?.[0]?.name ? permit?.permit_rate?.[0]?.name : permit?.name}</option>
								)
							})}
						</select>}
						<span className="form-text text-danger">{formError == 'home' && !formData?.permit_type ? 'This field is required' : ''}</span>
					</div>
				</div>

				{!isServiceDisabled && isPermissionExist(accessPermissions, 'Permit Service') ?
					<div className={'col-sm-4'}>
						<div className="mb-2 position-relative">
							<label className="form-label">Permit Services</label>

							{categoryLoader ? <div className="form-select"><Circles
								height="15"
								width="15"
								color="var(--bs-primary)"
								ariaLabel="circles-loading"
								visible={true}
							/></div> : <Multiselect
								options={formData?.permitServiceList} // Options to display in the dropdown
								selectedValues={formData?.permitService} // Preselected value to persist in dropdown
								onSelect={onSelect} // Function will trigger on select event
								onRemove={onRemove} // Function will trigger on remove event
								displayValue="name_rate" // Property name to display in the dropdown options
								showCheckbox={true}
								emptyRecordMsg={'Permit services not found.'}
								className='multi-select-service'
								hidePlaceholder={true}
								disable={isServiceDisabled}
							/>}

						</div>
					</div> : null}

				{/* PIMS-11105 */}
				{isDisplayFacility && isPermissionExist(accessPermissions, 'Hide Facility') ?
					<div className={partner == 'demo-parkengage' ? 'col-sm-3' : isPermissionExist(accessPermissions, 'Permit Category') ? 'col-sm-4' : 'col-sm-4'}>
						<div className="mb-2 position-relative">
							<label className="form-label">Parking Location <span className='text-danger'> *</span></label>
							<select name="facility_id" id="facility_id" className="form-select" onChange={handleInputFieldsData} >
								<option>Select Parking Location</option>
								{faclityList?.map((faclityListItem, faclityListIndex) => {
									return (
										<option value={faclityListItem?.id} selected={formData?.facility_id == faclityListItem?.id} key={faclityListIndex}>{faclityListItem?.full_name}</option>
									)
								})}
							</select>
							{!loader ? <span className='text-end small d-block mb-1'>
								<span className="form-text text-danger">{permitRateError ? permitRateError : ''}
								</span>
							</span> : null}
							<span className="form-text text-danger">{formError == 'home' && !formData?.facility_id ? 'This field is required' : ''}</span>
						</div>
					</div> : null}

				{isStaffDisabled ? null : isPermissionExist(accessPermissions, 'Category Type Id') ? <div className='col-sm-4'>
					<div className="mb-2 yankeeFix ">
						<label className="form-label"> Student/Staff/Faculty ID <span className='text-danger'> *</span></label>

						<input
							autoComplete="off"
							value={formData?.user_type_id}
							id="user_type_id"
							title="Student/Staff/Faculty ID"
							name='user_type_id'
							className="form-control"
							placeholder="Student/Staff/Faculty ID"
							maxLength="7"
							minLength="7"
							onChange={(e) => handleInputFieldsData(e, '')}
						/>

						<span className="form-text text-danger h-40">{formError == 'home' && !formData?.user_type_id ? 'This field is required' : (formData?.user_type_id && formData?.user_type_id?.length != 7) ? 'ID length should be 7' : ''}</span>
					</div>
				</div> : null}

				{formData?.selectedPermitType?.[0]?.is_hide_upload_id == '0' ? <div className='col-sm-4'>
					<DocumentUpload
						accept='image/*'
						onChange={(event) => universityUploadHandler(event, 'university_id', setUniversityidProof, universityidProof, setUniversityidErrProof, universityidErrProof)}
						name='university_id'
						id='university_id'
						idProof={universityidProof}
						formData={formData}
						label='Upload University ID'
						formError={formError}
						required={true} />
				</div> : null}


				{isPermissionExist(accessPermissions, 'Display Permit Start Date') ? <div className='col-sm-4'>
					<div className="mb-3 yankeeFix ">
						<label className="form-label"> Start Date </label>
						<div className=' d-flex border align-items-center justify-content-between'>
							<DatePicker
								selected={desiredStartDate}
								onChange={(date) => handleEntryTime(date)}
								className="form-control border-0 flex-basis-1 "
								timeIntervals={15}
								autoComplete="off"
								id="entry_time"
								name="entry_time"
								dateFormat="MMMM d, yyyy"
								minDate={desiredMinStartDate}
								maxDate={desiredEndDate}
								// minDate={new Date()}
								onKeyDown={(e) => {
									e.preventDefault()
								}}
							/>
							<i className=' fa fa-calendar-alt text-gray me-2' style={{ 'margin-left': '-100px', 'z-index': '2000', 'pointer-events': 'none' }} ></i>
						</div>

					</div>
				</div> : null}

				{searchParams?.get('permitID') ? <div className='col-sm-4 col'>
					<div className="mb-2 yankeeFix ">
						<label className="form-label">Business Account Number</label>
						<div className='reserve-space-wrapper position-relative'>
							<input
								autoComplete="off"
								value={permitDetailsById?.business_id}
								id="business_account_number"
								title="Business Account Number"
								name='business_account_number'
								className="form-control"
								placeholder=""
								maxLength="4"
								minLength="4"
								disabled
							/>
						</div>
					</div>
				</div> : null}

				{searchParams?.get('permitID') ? <div className='col-sm-4 col'>
					<div className="mb-2 yankeeFix ">
						<label className="form-label">PROX Card ID</label>
						<div className='reserve-space-wrapper position-relative'>
							<input
								autoComplete="off"
								value={permitDetailsById?.hid_card_number}
								id="prox_card_id"
								title="PROX Card ID"
								name='prox_card_id'
								className="form-control"
								placeholder=""
								maxLength="4"
								minLength="4"
								disabled
							/>
						</div>
					</div>
				</div> : null}

				{!isPermissionExist(accessPermissions, 'Driving License') ?
					<div className="col-sm-3 col-12">
						<div className="mb-2 position-relative">
							<label className="form-label">Driver License Number </label>
							<input
								className="form-control "
								name="license_number"
								id="license_number"
								maxLength={13}
								value={formData?.license_number}
								minLength={1}
								placeholder="License Number"
								required=""
								onKeyDown={restrictSpecialChar}
								disabled={(!loginData?.license_number) ? false : true}
								type="text"
								// onBlur={() => retrievePermitData(formData?.license_number, formData?.facility_id,faclityList)}
								onChange={(e) => handleLicenceNumberChange(e, 'change', formData?.facility_id)}
							/>
							<span className='text-end mb-2 d-block '>
								{resident == 'checking...' ? <span><Circles
									height="15"
									width="15"
									color="var(--bs-primary)"
									ariaLabel="circles-loading"
									visible={true}
								/></span> : <span className={resident == 'Invalid License Number' ? 'form-text text-danger' : 'form-text text-primary h-40'}><b>{formData?.license_number ? resident : ''}</b></span>}
								{/* <span className="form-text text-danger">{formError == 'home' && !formData?.license_number ? 'This field is required' : (formError == 'home' && formData?.license_number?.length < 7) ? 'Please enter a valid license number' : ''}</span> */}
							</span>
							{/* <span className="form-text text-danger">{formError == 'home' ? !formData?.license_number ? 'This field is required' : !validLicenceNumber.test(formData?.license_number?.trim()) ? 'Please enter a valid license number' : '' : ''}</span> */}
							{/* <span className="form-text text-danger">{formError == 'home' && !formData?.license_number ? 'This field is required' : ''}</span> */}

						</div>
					</div> : null}
				{/* remove */}


				{formData?.selFaclity?.facility_configuration?.permit_reserved_space_enabled == '1' ? <div className='col-sm-4 col'>
					<div className="mb-2 yankeeFix ">
						<label className="form-label">Preferred Reserved Space Number</label>
						<div className='reserve-space-wrapper position-relative'>
							<input className='form-control border-0 position-absolute reserve-space-input' type='text' disabled value='R-' />
							<input
								autoComplete="off"
								value={formData?.reserved_space_number}
								id="reserved_space_number"
								title="Preferred Reserved Space Number"
								name='reserved_space_number'
								className="form-control"
								placeholder=""
								maxLength="4"
								minLength="4"
								onChange={(e) => handleInputFieldsData(e, '')}
							/>
						</div>
						{/* <span className="form-text text-danger h-40">{(formData?.reserved_space_number && (formData?.reserved_space_number?.length !== 4)) ? 'Preferred Reserved Space Number should contains 4 Characters.' : ''}</span> */}
					</div>
				</div> : null}

				{!isPermissionExist(accessPermissions, 'Driving License') ? <>
					<FileUpload
						accept='image/*'
						onChange={(event) => fileChangedHandler(event, 'front', setIdProof, idProof, 300, 200, setIdErrProof, idErrProof)}
						name='front'
						id='front'
						idProof={idProof}
						formData={formData}
						required />

					<FileUpload
						accept='image/*'
						onChange={(event) => fileChangedHandler(event, 'back', setIdProof, idProof, 300, 200, setIdErrProof, idErrProof)}
						name='back'
						id='back'
						idProof={idProof}
						formData={formData}
						required />
					<div className='col-6'>
						{/* <span className="form-text text-danger">{formError == 'home' &&  idErrProof?.front == undefined ? 'This field is required' : ''}</span> */}
					</div>
					<div className='col-6'>
						{/* <span className="form-text text-danger">{formError == 'home' &&  idErrProof?.back == undefined ? 'This field is required' : ''}</span> */}

					</div>
					<small>
						(File type : jpeg, jpg, png)
					</small>

					<hr /></> : null}

			</div>
			{isDisplayReason ? <div className='col-12'>
				<div className="mb-2 yankeeFix ">
					<label className="form-label">Request Reason<span className='text-danger'> *</span></label>

					<input
						autoComplete="off"
						value={formData?.request_reason}
						id="request_reason"
						title="Request Reason"
						name='request_reason'
						className="form-control"
						placeholder="Request Reason"
						maxLength="200"
						minLength="30"
						onChange={(e) => handleInputFieldsData(e, '')}
					/>

					<span className="form-text text-danger h-40">{formError == 'home' && !formData?.request_reason ? 'This field is required' : (formData?.request_reason && (formData?.request_reason?.length < 30 || formData?.request_reason?.length > 200)) ? 'Content should contain atleast 30 Characters, and maximum 200 Characters.' : ''}</span>
				</div>
			</div> : null}
			{fetchingDocumentTypes ? <div className={'p-3 m-3 d-flex justify-content-center align-item-center'}>
				<Circles
					height={'40'}
					width={'40'}
					color="var(--bs-primary)"
					ariaLabel="circles-loading"
					wrapperStyle={{}}
					wrapperClass=""
					visible={true}
				/>
			</div> :
				documentTypes && documentTypes.length > 0 ? <div className={'clearfix border bg-light p-2 mb-3'} >

					<div className="block d-flex justify-content-between ">
						<label className="form-label">Upload Documents <span className="text-danger">*</span>
							<span className="small fw-normal d-block">(Please select one document at a time. <b>Each document listed must be uploaded.</b>)</span>
						</label>
					</div>
					<div className="row">
						<div className="col-md-4">
							<ul className="d-block nav ul-nav">
								{documentTypes?.map((item, index) => {
									return <li key={index}
										className="d-flex justify-content-between align-items-center">
										<label className="fw-normal">
											<input
												className="me-1"
												value={item?.document_key}
												checked={formData?.document_type == item?.document_key}
												name="document_type"
												disabled={isValuePresentInArray(idMultiProof, item?.document_key, 'type')}
												id="document_type"
												onChange={handleInputFieldsData}
												type="radio" /> {item?.document_name} <span className="text-danger">*</span>
										</label>
										{isValuePresentInArray(idMultiProof, item?.document_key, 'type') ? <i className="fa fa-check-circle text-success"></i> : <i className="fa fa-times-circle text-danger"></i>}
									</li>
								})}
							</ul>
						</div>
						<div className="col-md-4 p-2 offset-sm-1">
							<div className='row'>
								<FileUpload
									accept={getAcceptedDocument(selectedDocumentType?.document_type)}
									onChange={(event) => multiFileChangedHandler(event, formData?.document_type, setMultiIdProof, idMultiProof, 900, 600, notify, selectedDocumentType?.file_size_limit, selectedDocumentType?.document_type)}
									name={formData?.document_type}
									id={formData?.document_type}
									idProof={idMultiProof}
									formData={formData}
									required
									disabled={documentTypes.length == idMultiProof.length ? true : false}
									hideLabel
									className='col-12 col-md-12'
								// disabled={formData?.document_type && formData?.document_type != '' ? false : 'disabled'}
								// disabled={formData?.document_type && formData?.document_type != '' ? false : 'disabled'}


								/>
							</div>

							<small style={{
								'font-size': '11px',
								'font-weight': 'bold',
								'color': '#777'
							}}>

								{selectedDocumentType?.document_type ? `File type : (${getAcceptedFiles(selectedDocumentType?.document_type)})` : null} <br />
								{selectedDocumentType?.file_size_limit ? ` File Size Limit : ${selectedDocumentType?.file_size_limit}MB` : null}

							</small>
						</div>
					</div>
					<span className="form-text text-danger h-40">{formError == 'home' && idMultiProof?.length != documentTypes?.length ? 'Please upload all the required document' : ''}</span>

					{idMultiProof && idMultiProof?.length > 0 ? <div className='small mt-3'>
						<label className="form-label d-block mt-1 mb-0">Selected Documents</label>
						{idMultiProof?.map((item, index) => {
							return (
								<span className="border rounded border-primary ps-1 pe-1 bg-secondary text-white me-1" key={index}>{formatKeyInDocumentName(item?.type)}
									<i className='cursor-pointer ps-2 pe-1 fa fa-close fa-sm' onClick={() => handleDeleteDocument(item)} />
								</span>
							)
						})}

					</div> : null}

				</div> : null
			}

			{/* Employer Details section start */}
			{(isPermissionExist(accessPermissions, 'Display Employer Details') &&
				formData?.selFaclity?.facility_configuration?.permit_employer_name_enabled == '1' &&
				formData?.selectedPermitType?.[0]?.permit_rate?.[0]?.is_employer == '1')
				? <div className="my-2">
					<label className="form-label">Employer Details <sup className='text-danger'> *</sup></label>
					<div className="bg-light p-3">
						<div className="row g-2">
							<div className="col-sm-6">
								<TextInput
									label='Employer Name'
									validation={true}
									labelClass='text-muted'
									id="employer_name"
									name="employer_name"
									placeholder="Employer Name"
									maxLength={20}
									minLength={1}
									value={employerDetails?.employer_name ? employerDetails?.employer_name : ''}
									onChange={(e) => handleEmployerDetailsChange('employer_name', e.target.value)}
									type="text"
									errorMessage={validator.current.message('employer_name', employerDetails?.employer_name, 'required')}
								/>
							</div>
							<div className="col-sm-6">
								<label className="text-muted">Phone Number </label>
								<MaskedInput
									maskGenerator={phoneMaskGenerator}
									value={employerDetails?.employer_phone ? employerDetails?.employer_phone : ''}
									type="text"
									name="employer_phone"
									id="employer_phone"
									className="form-control"
									maxLength={14}
									minLength={14}
									title="Please enter a valid phone number"
									onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
									onInput={e => e.target.setCustomValidity('')}
									placeholder="Phone Number"
									onChange={e => handleEmployerDetailsChange('employer_phone', e)}
								/>
								{validator?.current?.message('employer_phone', employerDetails?.employer_phone, 'phone')}
							</div>
							<div className="col-sm-3 col-xs-6">
								<TextInput
									label="Address Line 1"
									labelClass="text-muted"
									id="employer_address1"
									name="employer_address1"
									placeholder="Address Line 1"
									maxLength={100}
									value={employerDetails?.employer_address1 ? employerDetails?.employer_address1 : ''}
									onChange={(e) => handleEmployerDetailsChange('employer_address1', e.target.value)}
									type="text"
								/>
							</div>
							<div className="col-sm-3 col-xs-6">
								<TextInput
									label="Address Line 2"
									labelClass="text-muted"
									name="employer_address2"
									placeholder="Address Line 2"
									maxLength={100}
									value={employerDetails?.employer_address2 ? employerDetails?.employer_address2 : ''}
									onChange={e => handleEmployerDetailsChange('employer_address2', e.target.value)}
									type="text"
								/>
							</div>
							{isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? (
								<div className="col-sm-3 col-xs-6">
									<label className="text-muted">Country</label>
									{(formData?.country && vehicleDetailsList?.country) ? (
										<select
											className='form-select form-control'
											placeholder="Country"
											name="employer_country"
											id='employer_country'
											onChange={(e) => handleEmployerDetailsChange('employer_country', e.target.value)}
											value={employerDetails?.employer_country ? employerDetails?.employer_country : ''}
										>
											<option value=''>Select an option</option>
											{(vehicleDetailsList?.country?.length > 0) && vehicleDetailsList?.country?.map((item, itemIndex) => {
												if (item?.country_code == 'US' || item?.country_code == 'CA' || item?.country_code == 'GB') {
													return (
														<option
															key={itemIndex + 1}
															value={item?.country_code}
															selected={
																item?.country_code == employerDetails?.employer_country ||
																item?.name == employerDetails?.employer_country
															}
														>
															{item?.name}
														</option>
													)
												}
											})}
										</select>
									) : (
										<div className="form-select">
											<Circles
												height="15"
												width="15"
												color="var(--bs-primary)"
												ariaLabel="circles-loading"
												visible={true}
											/>
										</div>
									)}
								</div>
							) : ''}
							<div className="col-sm-3 col-xs-6">
								<label className="text-muted">State</label>
								{(vehicleDetailsList?.state) ? (
									<select
										className='form-select form-control'
										placeholder="State"
										name="employer_state"
										id='employer_state'
										onChange={e => handleEmployerDetailsChange('employer_state', e.target.value)}
										value={employerDetails?.employer_state ? employerDetails?.employer_state : ''}
									>
										<option value=''>Select an option</option>
										{(vehicleDetailsList?.state?.length > 0) && vehicleDetailsList?.state?.map((item, itemIndex) => (
											<option
												key={itemIndex + 1}
												value={item?.state_code}
												selected={item?.id == employerDetails?.employer_state || item?.state_code == employerDetails?.employer_state}
											>
												{item?.state_code}
											</option>
										))}
									</select>
								) : (
									<div className="form-select">
										<Circles
											height="15"
											width="15"
											color="var(--bs-primary)"
											ariaLabel="circles-loading"
											visible={true}
										/>
									</div>
								)}
							</div>
							<div className="col-sm-3 col-xs-6">
								<TextInput
									label="City"
									labelClass="text-muted"
									name="employer_city"
									id="employer_city"
									maxLength={50}
									value={employerDetails?.employer_city ? employerDetails?.employer_city : ''}
									placeholder="City"
									type="text"
									onChange={e => handleEmployerDetailsChange('employer_city', e.target.value)}
								/>
							</div>
							<div className="col-sm-3 col-xs-6">
								<label className="text-muted">Zip Code</label>
								<input
									className="form-control"
									maxLength="6"
									minLength="5"
									name="employer_zipcode"
									autoComplete="new-password"
									value={employerDetails?.employer_zipcode ? employerDetails?.employer_zipcode : ''}
									placeholder="Zip Code"
									required
									type="text"
									onChange={e => handleEmployerDetailsChange('employer_zipcode', e.target.value)}
									onPaste={e => {
										e.preventDefault()
										return false
									}}
									onKeyPress={e => isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? restrictSpecialChar(e) : restrictInputValues(e)}
								/>
							</div>
						</div>
					</div>
				</div> : null
			}

			{/* Employer Details section end */}
			{isVehicleDisabled ? null : <div className=' mt-4'>
				<div className=" align-items-sm-center d-flex flex-column flex-sm-row justify-content-sm-between mb-2">
					<label className="form-label">Vehicle Information <sup className='text-danger'> *</sup> {(isPermissionExist(accessPermissions, 'Enable Vehicle Limit') && partnerDetails?.max_vehicle > 0) ? <span className='small fw-normal d-block'>Maximum vehicle allowed per permit ({partnerDetails?.max_vehicle})</span> : ''}</label>
					<div className='d-flex gap-1 align-items-center'>
						{((vehicleListArray?.length > 0) && isLoggedIn()) ? <div style={{ minWidth: '200px' }}>
							<MultiSelectInput
								options={vehicleListArray}
								selected={selectedVehicleList?.filter((v) => v?.id)}
								onSelectedChanged={(newSelected, option) => onVehicleListChange(newSelected, option)}
								displayValue="license_plate"
								hasSelectAll={vehicleListArray?.length > 2}
								disableSearch={vehicleListArray?.length < 2}
								overrideStrings={{
									selectSomeItems: 'Select vehicles',
									allItemsAreSelected: 'All vehicles selected',
									countSelected: (count) => `${count} vehicles selected` // or make it dynamic
								}}
							/>
						</div> : null}
						{((vehicleListArray?.length > 0) && isLoggedIn() && partner != 'menlo') ? <span className='text-primary mx-2'>OR</span> : null}
						{partner == 'menlo' ? null : <button
							type='button'
							className='btn btn-primary'
							disabled={canAddVehicle(selectedVehicleList?.slice() ?? [])?.limitExceeded}
							onClick={addVehicle}
						>
							<i className='fa fa-plus me-2'></i> Add New Vehicle
						</button>}
					</div>
				</div>

				{selectedVehicleList?.length > 0 ? isMobile ? mobileViewVehicleSection() : deskTopViewVehicleSection() : null}
				<small className='text-danger '>{error}</small>
			</div>}
			{/* Hide the facility details for diamond */}

			{selectedFaclity?.full_name &&
				<div className="bg-white border p-3 mt-1 mb-3">
					{categoryLoader ? <div className="d-flex justify-content-center"><Circles
						height="15"
						width="15"
						color="var(--bs-primary)"
						ariaLabel="circles-loading"
						visible={true}
					/></div>
						: <div className="row align-items-center justify-content-between ">
							<div className='col-sm-8 col-md-auto mb-sm-0 mb-3'>
								{formData?.permit_type && isPermissionExist(accessPermissions, 'Add Policy Url') ? <p className='mb-1 m-0 fw-bold'> <a href='https://usm.maine.edu/parking-services/' target='_blank' rel="noopener noreferrer" style={{ color: 'blue' }} className="small m-0"><i className='fa fa-link me-2'></i>Click For: Access Options/Where to Park/Rules </a></p> : ''}
								{isPermissionExist(accessPermissions, 'Hide Facility') ? null : <h4 className="text-primary">{selectedFaclity?.full_name}</h4>}
								{isPermissionExist(accessPermissions, 'Hide Facility') ? null : <p className="m-0 small"><b>Entrance Address: </b>{`${selectedFaclity?.geolocations?.address_1}${selectedFaclity?.geolocations?.address_2 ? `, ${selectedFaclity?.geolocations?.address_2}` : ''}${selectedFaclity?.geolocations?.city ? `, ${selectedFaclity?.geolocations?.city}` : ''}${selectedFaclity?.geolocations?.state ? `, ${selectedFaclity?.geolocations?.state}` : ''}${selectedFaclity?.geolocations?.zip_code ? `, ${selectedFaclity?.geolocations?.zip_code}` : ''}`}</p>}
								{/* {permitPrices?.description ? <p className="m-0 small"><b>Permit Validity :</b>{permitPrices?.description}</p> : ''} */}
								{permitPrices?.is_hide_validity == '0' && permitPrices?.description ? <p className="m-0 small"><b>Permit Validity: </b>{permitPrices?.description}</p> : ''}
								{!isPermissionExist(accessPermissions, 'Permit Category') ? (permitPrices?.permit_rate?.[0]?.permit_rate_criteria_mapping?.length > 0) ? perkingParkingTime(permitPrices?.permit_rate?.[0], true) : null : null}
							</div>

							{permitPrices?.permit_rate?.length > 0 ?
								<div className='col-sm-4 col-12' >

									{/* {permitPrices?.permit_rate?.map((permitPricesItem, permitPricesIndex) => {
									return (
										<> */}
									<div className="text-success ">
										<input type="radio" className="btn-check" name="permit_rate" id={'btnradio1'} autoComplete="off" checked />

										{permitPrices?.permit_rate?.[0] ? <label className=" position-relative w-100 text-sm-end" htmlFor={'btnradio1'}>
											<h2 className="fw-bold mb-0 text-primary">{permitPrices?.permit_rate?.[0]?.rate ? `$${formatDecimal(Number(permitPrices?.permit_rate?.[0]?.rate) + Number(formData?.permitServicePrice ? formData?.permitServicePrice : 0))}` : ''}</h2>
											<p className="mb-0 text-primary">{permitPrices?.permit_rate?.[0]?.name} </p>
											{/* {permitPrices?.description ? <p className="mb-0 text-primary">{permitPrices?.description} </p>:''} */}


										</label> : 'N/A'}

									</div>
									{/* </>
									)
								})} */}

								</div> : formData?.license_number &&
								<div className='col-sm-4 col-12'>

									<div className="text-success p-2">


										<label className=" position-relative w-100 text-end">
											<h2 className="fw-bold mb-0 text-primary">N/A</h2>
										</label>

									</div>
								</div>
							}

						</div>}
				</div>
			}


		</div>
	)
}

Home.propTypes = {
	dispatch: PropTypes.func,
	data: PropTypes.object,
	events: PropTypes.object,
	loader: PropTypes.bool,
	getCard: PropTypes.func,
	passData: PropTypes.object,
	setPage: PropTypes.func,
	setIdProof: PropTypes.func,
	front: PropTypes.string,
	back: PropTypes.string,
	idProof: PropTypes.object,
	formData: PropTypes.object,
	setFormData: PropTypes.func,
	formError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	partnerDetails: PropTypes.object,
	vehicleListArray: PropTypes.array,
	setVehicleListArray: PropTypes.func,
	setvehicleCount: PropTypes.func,
	vehicleCount: PropTypes.number,
	VehiclePrev: PropTypes.bool,
	categoryURL: PropTypes.bool,
	setMainVehicleMakeList: PropTypes.func,
	setUniversityidProof: PropTypes.func,
	universityidProof: PropTypes.object,
	setDocumentTypes: PropTypes.func,
	notify: PropTypes.func,
	documentTypes: PropTypes.object,
	selectedVehicleList: PropTypes.array,
	setSelectedVehicleList: PropTypes.func,
	setMultiIdProof: PropTypes.func,
	idMultiProof: PropTypes.array,
	employerDetails: PropTypes.object,
	setEmployerDetails: PropTypes.func,
	validator: PropTypes.func,
	accessPermissions: PropTypes.array,
}

Home.defaulProps = {
	dispatch: noop,
	data: EMPTY_OBJECT,
	events: EMPTY_OBJECT,
	loader: PropTypes.bool,
	getCard: PropTypes.func,
	passData: EMPTY_ARRAY,
	setPage: noop,
	setIdProof: noop,
	front: undefined,
	back: undefined,
	idProof: EMPTY_OBJECT,
	formData: EMPTY_OBJECT,
	setFormData: noop,
	formError: undefined,
	partnerDetails: EMPTY_OBJECT,
	vehicleListArray: EMPTY_ARRAY,
	setVehicleListArray: EMPTY_ARRAY,
	setvehicleCount: noop,
	vehicleCount: PropTypes.number,
	VehiclePrev: PropTypes.bool,
	categoryURL: PropTypes.bool,
	setMainVehicleMakeList: noop,
	setUniversityidProof: noop,
	universityidProof: EMPTY_OBJECT,
	setDocumentTypes: noop,
	documentTypes: EMPTY_OBJECT,
	notify: noop,
	setMultiIdProof: noop,
	idMultiProof: EMPTY_ARRAY
}

function mapStateToProps({ basicInfoReducer }) {
	return {
		loader: basicInfoReducer?.loader,
	}
}
export default connect(mapStateToProps)(Home)